/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 3.21.8
 * source: application/protocol/cluster-controller.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./../../protocol/concept";
import * as pb_1 from "google-protobuf";
export class ClusterCtlProto extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProto {
        const message = new ClusterCtlProto({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProto {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProto();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProto {
        return ClusterCtlProto.deserialize(bytes);
    }
}
export class ClusterCtlProtoReq extends pb_1.Message {
    #one_of_decls: number[][] = [[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27]];
    constructor(data?: any[] | ({} & (({
        getAccessLevels?: ClusterCtlProtoGetAccessLevelsReq;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: ClusterCtlProtoGetLatestCompatibleTypeDBReq;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: ClusterCtlProtoGetClusterDeploymentOptionsReq;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: ClusterCtlProtoGetClusterPriceReq;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: ClusterCtlProtoGetClusterPresetPriceReq;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: ClusterCtlProtoDeployClusterReq;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: ClusterCtlProtoGetClusterReq;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: ClusterCtlProtoUpdateClusterReq;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: ClusterCtlProtoPauseClusterReq;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: ClusterCtlProtoResumeClusterReq;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: ClusterCtlProtoDestroyClusterReq;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: ClusterCtlProtoListServersReq;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: ClusterCtlProtoListServerLogsReq;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: ClusterCtlProtoListClusterLogsReq;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: ClusterCtlProtoSetupClusterReq;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: ClusterCtlProtoCreateDatabaseReq;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: ClusterCtlProtoLoadSampleDatasetReq;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: ClusterCtlProtoGetClusterStorageUsageReq;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: ClusterCtlProtoTakeSnapshotReq;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: ClusterCtlProtoRestoreClusterReq;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: ClusterCtlProtoListSnapshotsReq;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: ClusterCtlProtoDeleteSnapshotReq;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: ClusterCtlProtoCheckClusterAutoPauseReq;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: ClusterCtlProtoMarkClusterAsActiveReq;
        cloneCluster?: never;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: ClusterCtlProtoCloneClusterReq;
        resetUserPassword?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        deployCluster?: never;
        getCluster?: never;
        updateCluster?: never;
        updateToLatestCompatibleTypedb?: never;
        pauseCluster?: never;
        resumeCluster?: never;
        destroyCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        setupCluster?: never;
        createDatabase?: never;
        loadSampleDataset?: never;
        getClusterStorageUsage?: never;
        takeSnapshot?: never;
        restoreCluster?: never;
        listSnapshots?: never;
        deleteSnapshot?: never;
        checkClusterAutoPause?: never;
        markClusterAsActive?: never;
        cloneCluster?: never;
        resetUserPassword?: ClusterCtlProtoResetUserPasswordReq;
    })))) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("getAccessLevels" in data && data.getAccessLevels != undefined) {
                this.getAccessLevels = data.getAccessLevels;
            }
            if ("getLatestCompatibleTypedb" in data && data.getLatestCompatibleTypedb != undefined) {
                this.getLatestCompatibleTypedb = data.getLatestCompatibleTypedb;
            }
            if ("getClusterDeploymentOptions" in data && data.getClusterDeploymentOptions != undefined) {
                this.getClusterDeploymentOptions = data.getClusterDeploymentOptions;
            }
            if ("getClusterPrice" in data && data.getClusterPrice != undefined) {
                this.getClusterPrice = data.getClusterPrice;
            }
            if ("getClusterPresetPrice" in data && data.getClusterPresetPrice != undefined) {
                this.getClusterPresetPrice = data.getClusterPresetPrice;
            }
            if ("deployCluster" in data && data.deployCluster != undefined) {
                this.deployCluster = data.deployCluster;
            }
            if ("getCluster" in data && data.getCluster != undefined) {
                this.getCluster = data.getCluster;
            }
            if ("updateCluster" in data && data.updateCluster != undefined) {
                this.updateCluster = data.updateCluster;
            }
            if ("updateToLatestCompatibleTypedb" in data && data.updateToLatestCompatibleTypedb != undefined) {
                this.updateToLatestCompatibleTypedb = data.updateToLatestCompatibleTypedb;
            }
            if ("pauseCluster" in data && data.pauseCluster != undefined) {
                this.pauseCluster = data.pauseCluster;
            }
            if ("resumeCluster" in data && data.resumeCluster != undefined) {
                this.resumeCluster = data.resumeCluster;
            }
            if ("destroyCluster" in data && data.destroyCluster != undefined) {
                this.destroyCluster = data.destroyCluster;
            }
            if ("listServers" in data && data.listServers != undefined) {
                this.listServers = data.listServers;
            }
            if ("listServerLogs" in data && data.listServerLogs != undefined) {
                this.listServerLogs = data.listServerLogs;
            }
            if ("listClusterLogs" in data && data.listClusterLogs != undefined) {
                this.listClusterLogs = data.listClusterLogs;
            }
            if ("setupCluster" in data && data.setupCluster != undefined) {
                this.setupCluster = data.setupCluster;
            }
            if ("createDatabase" in data && data.createDatabase != undefined) {
                this.createDatabase = data.createDatabase;
            }
            if ("loadSampleDataset" in data && data.loadSampleDataset != undefined) {
                this.loadSampleDataset = data.loadSampleDataset;
            }
            if ("getClusterStorageUsage" in data && data.getClusterStorageUsage != undefined) {
                this.getClusterStorageUsage = data.getClusterStorageUsage;
            }
            if ("takeSnapshot" in data && data.takeSnapshot != undefined) {
                this.takeSnapshot = data.takeSnapshot;
            }
            if ("restoreCluster" in data && data.restoreCluster != undefined) {
                this.restoreCluster = data.restoreCluster;
            }
            if ("listSnapshots" in data && data.listSnapshots != undefined) {
                this.listSnapshots = data.listSnapshots;
            }
            if ("deleteSnapshot" in data && data.deleteSnapshot != undefined) {
                this.deleteSnapshot = data.deleteSnapshot;
            }
            if ("checkClusterAutoPause" in data && data.checkClusterAutoPause != undefined) {
                this.checkClusterAutoPause = data.checkClusterAutoPause;
            }
            if ("markClusterAsActive" in data && data.markClusterAsActive != undefined) {
                this.markClusterAsActive = data.markClusterAsActive;
            }
            if ("cloneCluster" in data && data.cloneCluster != undefined) {
                this.cloneCluster = data.cloneCluster;
            }
            if ("resetUserPassword" in data && data.resetUserPassword != undefined) {
                this.resetUserPassword = data.resetUserPassword;
            }
        }
    }
    get getAccessLevels() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetAccessLevelsReq, 1) as ClusterCtlProtoGetAccessLevelsReq;
    }
    set getAccessLevels(value: ClusterCtlProtoGetAccessLevelsReq) {
        pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
    }
    get hasGetAccessLevels() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get getLatestCompatibleTypedb() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetLatestCompatibleTypeDBReq, 2) as ClusterCtlProtoGetLatestCompatibleTypeDBReq;
    }
    set getLatestCompatibleTypedb(value: ClusterCtlProtoGetLatestCompatibleTypeDBReq) {
        pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[0], value);
    }
    get hasGetLatestCompatibleTypedb() {
        return pb_1.Message.getField(this, 2) != null;
    }
    get getClusterDeploymentOptions() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetClusterDeploymentOptionsReq, 3) as ClusterCtlProtoGetClusterDeploymentOptionsReq;
    }
    set getClusterDeploymentOptions(value: ClusterCtlProtoGetClusterDeploymentOptionsReq) {
        pb_1.Message.setOneofWrapperField(this, 3, this.#one_of_decls[0], value);
    }
    get hasGetClusterDeploymentOptions() {
        return pb_1.Message.getField(this, 3) != null;
    }
    get getClusterPrice() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetClusterPriceReq, 4) as ClusterCtlProtoGetClusterPriceReq;
    }
    set getClusterPrice(value: ClusterCtlProtoGetClusterPriceReq) {
        pb_1.Message.setOneofWrapperField(this, 4, this.#one_of_decls[0], value);
    }
    get hasGetClusterPrice() {
        return pb_1.Message.getField(this, 4) != null;
    }
    get getClusterPresetPrice() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetClusterPresetPriceReq, 5) as ClusterCtlProtoGetClusterPresetPriceReq;
    }
    set getClusterPresetPrice(value: ClusterCtlProtoGetClusterPresetPriceReq) {
        pb_1.Message.setOneofWrapperField(this, 5, this.#one_of_decls[0], value);
    }
    get hasGetClusterPresetPrice() {
        return pb_1.Message.getField(this, 5) != null;
    }
    get deployCluster() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoDeployClusterReq, 6) as ClusterCtlProtoDeployClusterReq;
    }
    set deployCluster(value: ClusterCtlProtoDeployClusterReq) {
        pb_1.Message.setOneofWrapperField(this, 6, this.#one_of_decls[0], value);
    }
    get hasDeployCluster() {
        return pb_1.Message.getField(this, 6) != null;
    }
    get getCluster() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetClusterReq, 7) as ClusterCtlProtoGetClusterReq;
    }
    set getCluster(value: ClusterCtlProtoGetClusterReq) {
        pb_1.Message.setOneofWrapperField(this, 7, this.#one_of_decls[0], value);
    }
    get hasGetCluster() {
        return pb_1.Message.getField(this, 7) != null;
    }
    get updateCluster() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoUpdateClusterReq, 8) as ClusterCtlProtoUpdateClusterReq;
    }
    set updateCluster(value: ClusterCtlProtoUpdateClusterReq) {
        pb_1.Message.setOneofWrapperField(this, 8, this.#one_of_decls[0], value);
    }
    get hasUpdateCluster() {
        return pb_1.Message.getField(this, 8) != null;
    }
    get updateToLatestCompatibleTypedb() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq, 9) as ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq;
    }
    set updateToLatestCompatibleTypedb(value: ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq) {
        pb_1.Message.setOneofWrapperField(this, 9, this.#one_of_decls[0], value);
    }
    get hasUpdateToLatestCompatibleTypedb() {
        return pb_1.Message.getField(this, 9) != null;
    }
    get pauseCluster() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoPauseClusterReq, 10) as ClusterCtlProtoPauseClusterReq;
    }
    set pauseCluster(value: ClusterCtlProtoPauseClusterReq) {
        pb_1.Message.setOneofWrapperField(this, 10, this.#one_of_decls[0], value);
    }
    get hasPauseCluster() {
        return pb_1.Message.getField(this, 10) != null;
    }
    get resumeCluster() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoResumeClusterReq, 11) as ClusterCtlProtoResumeClusterReq;
    }
    set resumeCluster(value: ClusterCtlProtoResumeClusterReq) {
        pb_1.Message.setOneofWrapperField(this, 11, this.#one_of_decls[0], value);
    }
    get hasResumeCluster() {
        return pb_1.Message.getField(this, 11) != null;
    }
    get destroyCluster() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoDestroyClusterReq, 12) as ClusterCtlProtoDestroyClusterReq;
    }
    set destroyCluster(value: ClusterCtlProtoDestroyClusterReq) {
        pb_1.Message.setOneofWrapperField(this, 12, this.#one_of_decls[0], value);
    }
    get hasDestroyCluster() {
        return pb_1.Message.getField(this, 12) != null;
    }
    get listServers() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoListServersReq, 13) as ClusterCtlProtoListServersReq;
    }
    set listServers(value: ClusterCtlProtoListServersReq) {
        pb_1.Message.setOneofWrapperField(this, 13, this.#one_of_decls[0], value);
    }
    get hasListServers() {
        return pb_1.Message.getField(this, 13) != null;
    }
    get listServerLogs() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoListServerLogsReq, 14) as ClusterCtlProtoListServerLogsReq;
    }
    set listServerLogs(value: ClusterCtlProtoListServerLogsReq) {
        pb_1.Message.setOneofWrapperField(this, 14, this.#one_of_decls[0], value);
    }
    get hasListServerLogs() {
        return pb_1.Message.getField(this, 14) != null;
    }
    get listClusterLogs() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoListClusterLogsReq, 15) as ClusterCtlProtoListClusterLogsReq;
    }
    set listClusterLogs(value: ClusterCtlProtoListClusterLogsReq) {
        pb_1.Message.setOneofWrapperField(this, 15, this.#one_of_decls[0], value);
    }
    get hasListClusterLogs() {
        return pb_1.Message.getField(this, 15) != null;
    }
    get setupCluster() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoSetupClusterReq, 16) as ClusterCtlProtoSetupClusterReq;
    }
    set setupCluster(value: ClusterCtlProtoSetupClusterReq) {
        pb_1.Message.setOneofWrapperField(this, 16, this.#one_of_decls[0], value);
    }
    get hasSetupCluster() {
        return pb_1.Message.getField(this, 16) != null;
    }
    get createDatabase() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoCreateDatabaseReq, 17) as ClusterCtlProtoCreateDatabaseReq;
    }
    set createDatabase(value: ClusterCtlProtoCreateDatabaseReq) {
        pb_1.Message.setOneofWrapperField(this, 17, this.#one_of_decls[0], value);
    }
    get hasCreateDatabase() {
        return pb_1.Message.getField(this, 17) != null;
    }
    get loadSampleDataset() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoLoadSampleDatasetReq, 18) as ClusterCtlProtoLoadSampleDatasetReq;
    }
    set loadSampleDataset(value: ClusterCtlProtoLoadSampleDatasetReq) {
        pb_1.Message.setOneofWrapperField(this, 18, this.#one_of_decls[0], value);
    }
    get hasLoadSampleDataset() {
        return pb_1.Message.getField(this, 18) != null;
    }
    get getClusterStorageUsage() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetClusterStorageUsageReq, 19) as ClusterCtlProtoGetClusterStorageUsageReq;
    }
    set getClusterStorageUsage(value: ClusterCtlProtoGetClusterStorageUsageReq) {
        pb_1.Message.setOneofWrapperField(this, 19, this.#one_of_decls[0], value);
    }
    get hasGetClusterStorageUsage() {
        return pb_1.Message.getField(this, 19) != null;
    }
    get takeSnapshot() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoTakeSnapshotReq, 20) as ClusterCtlProtoTakeSnapshotReq;
    }
    set takeSnapshot(value: ClusterCtlProtoTakeSnapshotReq) {
        pb_1.Message.setOneofWrapperField(this, 20, this.#one_of_decls[0], value);
    }
    get hasTakeSnapshot() {
        return pb_1.Message.getField(this, 20) != null;
    }
    get restoreCluster() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoRestoreClusterReq, 21) as ClusterCtlProtoRestoreClusterReq;
    }
    set restoreCluster(value: ClusterCtlProtoRestoreClusterReq) {
        pb_1.Message.setOneofWrapperField(this, 21, this.#one_of_decls[0], value);
    }
    get hasRestoreCluster() {
        return pb_1.Message.getField(this, 21) != null;
    }
    get listSnapshots() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoListSnapshotsReq, 22) as ClusterCtlProtoListSnapshotsReq;
    }
    set listSnapshots(value: ClusterCtlProtoListSnapshotsReq) {
        pb_1.Message.setOneofWrapperField(this, 22, this.#one_of_decls[0], value);
    }
    get hasListSnapshots() {
        return pb_1.Message.getField(this, 22) != null;
    }
    get deleteSnapshot() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoDeleteSnapshotReq, 23) as ClusterCtlProtoDeleteSnapshotReq;
    }
    set deleteSnapshot(value: ClusterCtlProtoDeleteSnapshotReq) {
        pb_1.Message.setOneofWrapperField(this, 23, this.#one_of_decls[0], value);
    }
    get hasDeleteSnapshot() {
        return pb_1.Message.getField(this, 23) != null;
    }
    get checkClusterAutoPause() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoCheckClusterAutoPauseReq, 24) as ClusterCtlProtoCheckClusterAutoPauseReq;
    }
    set checkClusterAutoPause(value: ClusterCtlProtoCheckClusterAutoPauseReq) {
        pb_1.Message.setOneofWrapperField(this, 24, this.#one_of_decls[0], value);
    }
    get hasCheckClusterAutoPause() {
        return pb_1.Message.getField(this, 24) != null;
    }
    get markClusterAsActive() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoMarkClusterAsActiveReq, 25) as ClusterCtlProtoMarkClusterAsActiveReq;
    }
    set markClusterAsActive(value: ClusterCtlProtoMarkClusterAsActiveReq) {
        pb_1.Message.setOneofWrapperField(this, 25, this.#one_of_decls[0], value);
    }
    get hasMarkClusterAsActive() {
        return pb_1.Message.getField(this, 25) != null;
    }
    get cloneCluster() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoCloneClusterReq, 26) as ClusterCtlProtoCloneClusterReq;
    }
    set cloneCluster(value: ClusterCtlProtoCloneClusterReq) {
        pb_1.Message.setOneofWrapperField(this, 26, this.#one_of_decls[0], value);
    }
    get hasCloneCluster() {
        return pb_1.Message.getField(this, 26) != null;
    }
    get resetUserPassword() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoResetUserPasswordReq, 27) as ClusterCtlProtoResetUserPasswordReq;
    }
    set resetUserPassword(value: ClusterCtlProtoResetUserPasswordReq) {
        pb_1.Message.setOneofWrapperField(this, 27, this.#one_of_decls[0], value);
    }
    get hasResetUserPassword() {
        return pb_1.Message.getField(this, 27) != null;
    }
    get req() {
        const cases: {
            [index: number]: "none" | "getAccessLevels" | "getLatestCompatibleTypedb" | "getClusterDeploymentOptions" | "getClusterPrice" | "getClusterPresetPrice" | "deployCluster" | "getCluster" | "updateCluster" | "updateToLatestCompatibleTypedb" | "pauseCluster" | "resumeCluster" | "destroyCluster" | "listServers" | "listServerLogs" | "listClusterLogs" | "setupCluster" | "createDatabase" | "loadSampleDataset" | "getClusterStorageUsage" | "takeSnapshot" | "restoreCluster" | "listSnapshots" | "deleteSnapshot" | "checkClusterAutoPause" | "markClusterAsActive" | "cloneCluster" | "resetUserPassword";
        } = {
            0: "none",
            1: "getAccessLevels",
            2: "getLatestCompatibleTypedb",
            3: "getClusterDeploymentOptions",
            4: "getClusterPrice",
            5: "getClusterPresetPrice",
            6: "deployCluster",
            7: "getCluster",
            8: "updateCluster",
            9: "updateToLatestCompatibleTypedb",
            10: "pauseCluster",
            11: "resumeCluster",
            12: "destroyCluster",
            13: "listServers",
            14: "listServerLogs",
            15: "listClusterLogs",
            16: "setupCluster",
            17: "createDatabase",
            18: "loadSampleDataset",
            19: "getClusterStorageUsage",
            20: "takeSnapshot",
            21: "restoreCluster",
            22: "listSnapshots",
            23: "deleteSnapshot",
            24: "checkClusterAutoPause",
            25: "markClusterAsActive",
            26: "cloneCluster",
            27: "resetUserPassword"
        };
        return cases[pb_1.Message.computeOneofCase(this, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27])];
    }
    static fromObject(data: {
        getAccessLevels?: ReturnType<typeof ClusterCtlProtoGetAccessLevelsReq.prototype.toObject>;
        getLatestCompatibleTypedb?: ReturnType<typeof ClusterCtlProtoGetLatestCompatibleTypeDBReq.prototype.toObject>;
        getClusterDeploymentOptions?: ReturnType<typeof ClusterCtlProtoGetClusterDeploymentOptionsReq.prototype.toObject>;
        getClusterPrice?: ReturnType<typeof ClusterCtlProtoGetClusterPriceReq.prototype.toObject>;
        getClusterPresetPrice?: ReturnType<typeof ClusterCtlProtoGetClusterPresetPriceReq.prototype.toObject>;
        deployCluster?: ReturnType<typeof ClusterCtlProtoDeployClusterReq.prototype.toObject>;
        getCluster?: ReturnType<typeof ClusterCtlProtoGetClusterReq.prototype.toObject>;
        updateCluster?: ReturnType<typeof ClusterCtlProtoUpdateClusterReq.prototype.toObject>;
        updateToLatestCompatibleTypedb?: ReturnType<typeof ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq.prototype.toObject>;
        pauseCluster?: ReturnType<typeof ClusterCtlProtoPauseClusterReq.prototype.toObject>;
        resumeCluster?: ReturnType<typeof ClusterCtlProtoResumeClusterReq.prototype.toObject>;
        destroyCluster?: ReturnType<typeof ClusterCtlProtoDestroyClusterReq.prototype.toObject>;
        listServers?: ReturnType<typeof ClusterCtlProtoListServersReq.prototype.toObject>;
        listServerLogs?: ReturnType<typeof ClusterCtlProtoListServerLogsReq.prototype.toObject>;
        listClusterLogs?: ReturnType<typeof ClusterCtlProtoListClusterLogsReq.prototype.toObject>;
        setupCluster?: ReturnType<typeof ClusterCtlProtoSetupClusterReq.prototype.toObject>;
        createDatabase?: ReturnType<typeof ClusterCtlProtoCreateDatabaseReq.prototype.toObject>;
        loadSampleDataset?: ReturnType<typeof ClusterCtlProtoLoadSampleDatasetReq.prototype.toObject>;
        getClusterStorageUsage?: ReturnType<typeof ClusterCtlProtoGetClusterStorageUsageReq.prototype.toObject>;
        takeSnapshot?: ReturnType<typeof ClusterCtlProtoTakeSnapshotReq.prototype.toObject>;
        restoreCluster?: ReturnType<typeof ClusterCtlProtoRestoreClusterReq.prototype.toObject>;
        listSnapshots?: ReturnType<typeof ClusterCtlProtoListSnapshotsReq.prototype.toObject>;
        deleteSnapshot?: ReturnType<typeof ClusterCtlProtoDeleteSnapshotReq.prototype.toObject>;
        checkClusterAutoPause?: ReturnType<typeof ClusterCtlProtoCheckClusterAutoPauseReq.prototype.toObject>;
        markClusterAsActive?: ReturnType<typeof ClusterCtlProtoMarkClusterAsActiveReq.prototype.toObject>;
        cloneCluster?: ReturnType<typeof ClusterCtlProtoCloneClusterReq.prototype.toObject>;
        resetUserPassword?: ReturnType<typeof ClusterCtlProtoResetUserPasswordReq.prototype.toObject>;
    }): ClusterCtlProtoReq {
        const message = new ClusterCtlProtoReq({});
        if (data.getAccessLevels != null) {
            message.getAccessLevels = ClusterCtlProtoGetAccessLevelsReq.fromObject(data.getAccessLevels);
        }
        if (data.getLatestCompatibleTypedb != null) {
            message.getLatestCompatibleTypedb = ClusterCtlProtoGetLatestCompatibleTypeDBReq.fromObject(data.getLatestCompatibleTypedb);
        }
        if (data.getClusterDeploymentOptions != null) {
            message.getClusterDeploymentOptions = ClusterCtlProtoGetClusterDeploymentOptionsReq.fromObject(data.getClusterDeploymentOptions);
        }
        if (data.getClusterPrice != null) {
            message.getClusterPrice = ClusterCtlProtoGetClusterPriceReq.fromObject(data.getClusterPrice);
        }
        if (data.getClusterPresetPrice != null) {
            message.getClusterPresetPrice = ClusterCtlProtoGetClusterPresetPriceReq.fromObject(data.getClusterPresetPrice);
        }
        if (data.deployCluster != null) {
            message.deployCluster = ClusterCtlProtoDeployClusterReq.fromObject(data.deployCluster);
        }
        if (data.getCluster != null) {
            message.getCluster = ClusterCtlProtoGetClusterReq.fromObject(data.getCluster);
        }
        if (data.updateCluster != null) {
            message.updateCluster = ClusterCtlProtoUpdateClusterReq.fromObject(data.updateCluster);
        }
        if (data.updateToLatestCompatibleTypedb != null) {
            message.updateToLatestCompatibleTypedb = ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq.fromObject(data.updateToLatestCompatibleTypedb);
        }
        if (data.pauseCluster != null) {
            message.pauseCluster = ClusterCtlProtoPauseClusterReq.fromObject(data.pauseCluster);
        }
        if (data.resumeCluster != null) {
            message.resumeCluster = ClusterCtlProtoResumeClusterReq.fromObject(data.resumeCluster);
        }
        if (data.destroyCluster != null) {
            message.destroyCluster = ClusterCtlProtoDestroyClusterReq.fromObject(data.destroyCluster);
        }
        if (data.listServers != null) {
            message.listServers = ClusterCtlProtoListServersReq.fromObject(data.listServers);
        }
        if (data.listServerLogs != null) {
            message.listServerLogs = ClusterCtlProtoListServerLogsReq.fromObject(data.listServerLogs);
        }
        if (data.listClusterLogs != null) {
            message.listClusterLogs = ClusterCtlProtoListClusterLogsReq.fromObject(data.listClusterLogs);
        }
        if (data.setupCluster != null) {
            message.setupCluster = ClusterCtlProtoSetupClusterReq.fromObject(data.setupCluster);
        }
        if (data.createDatabase != null) {
            message.createDatabase = ClusterCtlProtoCreateDatabaseReq.fromObject(data.createDatabase);
        }
        if (data.loadSampleDataset != null) {
            message.loadSampleDataset = ClusterCtlProtoLoadSampleDatasetReq.fromObject(data.loadSampleDataset);
        }
        if (data.getClusterStorageUsage != null) {
            message.getClusterStorageUsage = ClusterCtlProtoGetClusterStorageUsageReq.fromObject(data.getClusterStorageUsage);
        }
        if (data.takeSnapshot != null) {
            message.takeSnapshot = ClusterCtlProtoTakeSnapshotReq.fromObject(data.takeSnapshot);
        }
        if (data.restoreCluster != null) {
            message.restoreCluster = ClusterCtlProtoRestoreClusterReq.fromObject(data.restoreCluster);
        }
        if (data.listSnapshots != null) {
            message.listSnapshots = ClusterCtlProtoListSnapshotsReq.fromObject(data.listSnapshots);
        }
        if (data.deleteSnapshot != null) {
            message.deleteSnapshot = ClusterCtlProtoDeleteSnapshotReq.fromObject(data.deleteSnapshot);
        }
        if (data.checkClusterAutoPause != null) {
            message.checkClusterAutoPause = ClusterCtlProtoCheckClusterAutoPauseReq.fromObject(data.checkClusterAutoPause);
        }
        if (data.markClusterAsActive != null) {
            message.markClusterAsActive = ClusterCtlProtoMarkClusterAsActiveReq.fromObject(data.markClusterAsActive);
        }
        if (data.cloneCluster != null) {
            message.cloneCluster = ClusterCtlProtoCloneClusterReq.fromObject(data.cloneCluster);
        }
        if (data.resetUserPassword != null) {
            message.resetUserPassword = ClusterCtlProtoResetUserPasswordReq.fromObject(data.resetUserPassword);
        }
        return message;
    }
    toObject() {
        const data: {
            getAccessLevels?: ReturnType<typeof ClusterCtlProtoGetAccessLevelsReq.prototype.toObject>;
            getLatestCompatibleTypedb?: ReturnType<typeof ClusterCtlProtoGetLatestCompatibleTypeDBReq.prototype.toObject>;
            getClusterDeploymentOptions?: ReturnType<typeof ClusterCtlProtoGetClusterDeploymentOptionsReq.prototype.toObject>;
            getClusterPrice?: ReturnType<typeof ClusterCtlProtoGetClusterPriceReq.prototype.toObject>;
            getClusterPresetPrice?: ReturnType<typeof ClusterCtlProtoGetClusterPresetPriceReq.prototype.toObject>;
            deployCluster?: ReturnType<typeof ClusterCtlProtoDeployClusterReq.prototype.toObject>;
            getCluster?: ReturnType<typeof ClusterCtlProtoGetClusterReq.prototype.toObject>;
            updateCluster?: ReturnType<typeof ClusterCtlProtoUpdateClusterReq.prototype.toObject>;
            updateToLatestCompatibleTypedb?: ReturnType<typeof ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq.prototype.toObject>;
            pauseCluster?: ReturnType<typeof ClusterCtlProtoPauseClusterReq.prototype.toObject>;
            resumeCluster?: ReturnType<typeof ClusterCtlProtoResumeClusterReq.prototype.toObject>;
            destroyCluster?: ReturnType<typeof ClusterCtlProtoDestroyClusterReq.prototype.toObject>;
            listServers?: ReturnType<typeof ClusterCtlProtoListServersReq.prototype.toObject>;
            listServerLogs?: ReturnType<typeof ClusterCtlProtoListServerLogsReq.prototype.toObject>;
            listClusterLogs?: ReturnType<typeof ClusterCtlProtoListClusterLogsReq.prototype.toObject>;
            setupCluster?: ReturnType<typeof ClusterCtlProtoSetupClusterReq.prototype.toObject>;
            createDatabase?: ReturnType<typeof ClusterCtlProtoCreateDatabaseReq.prototype.toObject>;
            loadSampleDataset?: ReturnType<typeof ClusterCtlProtoLoadSampleDatasetReq.prototype.toObject>;
            getClusterStorageUsage?: ReturnType<typeof ClusterCtlProtoGetClusterStorageUsageReq.prototype.toObject>;
            takeSnapshot?: ReturnType<typeof ClusterCtlProtoTakeSnapshotReq.prototype.toObject>;
            restoreCluster?: ReturnType<typeof ClusterCtlProtoRestoreClusterReq.prototype.toObject>;
            listSnapshots?: ReturnType<typeof ClusterCtlProtoListSnapshotsReq.prototype.toObject>;
            deleteSnapshot?: ReturnType<typeof ClusterCtlProtoDeleteSnapshotReq.prototype.toObject>;
            checkClusterAutoPause?: ReturnType<typeof ClusterCtlProtoCheckClusterAutoPauseReq.prototype.toObject>;
            markClusterAsActive?: ReturnType<typeof ClusterCtlProtoMarkClusterAsActiveReq.prototype.toObject>;
            cloneCluster?: ReturnType<typeof ClusterCtlProtoCloneClusterReq.prototype.toObject>;
            resetUserPassword?: ReturnType<typeof ClusterCtlProtoResetUserPasswordReq.prototype.toObject>;
        } = {};
        if (this.getAccessLevels != null) {
            data.getAccessLevels = this.getAccessLevels.toObject();
        }
        if (this.getLatestCompatibleTypedb != null) {
            data.getLatestCompatibleTypedb = this.getLatestCompatibleTypedb.toObject();
        }
        if (this.getClusterDeploymentOptions != null) {
            data.getClusterDeploymentOptions = this.getClusterDeploymentOptions.toObject();
        }
        if (this.getClusterPrice != null) {
            data.getClusterPrice = this.getClusterPrice.toObject();
        }
        if (this.getClusterPresetPrice != null) {
            data.getClusterPresetPrice = this.getClusterPresetPrice.toObject();
        }
        if (this.deployCluster != null) {
            data.deployCluster = this.deployCluster.toObject();
        }
        if (this.getCluster != null) {
            data.getCluster = this.getCluster.toObject();
        }
        if (this.updateCluster != null) {
            data.updateCluster = this.updateCluster.toObject();
        }
        if (this.updateToLatestCompatibleTypedb != null) {
            data.updateToLatestCompatibleTypedb = this.updateToLatestCompatibleTypedb.toObject();
        }
        if (this.pauseCluster != null) {
            data.pauseCluster = this.pauseCluster.toObject();
        }
        if (this.resumeCluster != null) {
            data.resumeCluster = this.resumeCluster.toObject();
        }
        if (this.destroyCluster != null) {
            data.destroyCluster = this.destroyCluster.toObject();
        }
        if (this.listServers != null) {
            data.listServers = this.listServers.toObject();
        }
        if (this.listServerLogs != null) {
            data.listServerLogs = this.listServerLogs.toObject();
        }
        if (this.listClusterLogs != null) {
            data.listClusterLogs = this.listClusterLogs.toObject();
        }
        if (this.setupCluster != null) {
            data.setupCluster = this.setupCluster.toObject();
        }
        if (this.createDatabase != null) {
            data.createDatabase = this.createDatabase.toObject();
        }
        if (this.loadSampleDataset != null) {
            data.loadSampleDataset = this.loadSampleDataset.toObject();
        }
        if (this.getClusterStorageUsage != null) {
            data.getClusterStorageUsage = this.getClusterStorageUsage.toObject();
        }
        if (this.takeSnapshot != null) {
            data.takeSnapshot = this.takeSnapshot.toObject();
        }
        if (this.restoreCluster != null) {
            data.restoreCluster = this.restoreCluster.toObject();
        }
        if (this.listSnapshots != null) {
            data.listSnapshots = this.listSnapshots.toObject();
        }
        if (this.deleteSnapshot != null) {
            data.deleteSnapshot = this.deleteSnapshot.toObject();
        }
        if (this.checkClusterAutoPause != null) {
            data.checkClusterAutoPause = this.checkClusterAutoPause.toObject();
        }
        if (this.markClusterAsActive != null) {
            data.markClusterAsActive = this.markClusterAsActive.toObject();
        }
        if (this.cloneCluster != null) {
            data.cloneCluster = this.cloneCluster.toObject();
        }
        if (this.resetUserPassword != null) {
            data.resetUserPassword = this.resetUserPassword.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.hasGetAccessLevels)
            writer.writeMessage(1, this.getAccessLevels, () => this.getAccessLevels.serialize(writer));
        if (this.hasGetLatestCompatibleTypedb)
            writer.writeMessage(2, this.getLatestCompatibleTypedb, () => this.getLatestCompatibleTypedb.serialize(writer));
        if (this.hasGetClusterDeploymentOptions)
            writer.writeMessage(3, this.getClusterDeploymentOptions, () => this.getClusterDeploymentOptions.serialize(writer));
        if (this.hasGetClusterPrice)
            writer.writeMessage(4, this.getClusterPrice, () => this.getClusterPrice.serialize(writer));
        if (this.hasGetClusterPresetPrice)
            writer.writeMessage(5, this.getClusterPresetPrice, () => this.getClusterPresetPrice.serialize(writer));
        if (this.hasDeployCluster)
            writer.writeMessage(6, this.deployCluster, () => this.deployCluster.serialize(writer));
        if (this.hasGetCluster)
            writer.writeMessage(7, this.getCluster, () => this.getCluster.serialize(writer));
        if (this.hasUpdateCluster)
            writer.writeMessage(8, this.updateCluster, () => this.updateCluster.serialize(writer));
        if (this.hasUpdateToLatestCompatibleTypedb)
            writer.writeMessage(9, this.updateToLatestCompatibleTypedb, () => this.updateToLatestCompatibleTypedb.serialize(writer));
        if (this.hasPauseCluster)
            writer.writeMessage(10, this.pauseCluster, () => this.pauseCluster.serialize(writer));
        if (this.hasResumeCluster)
            writer.writeMessage(11, this.resumeCluster, () => this.resumeCluster.serialize(writer));
        if (this.hasDestroyCluster)
            writer.writeMessage(12, this.destroyCluster, () => this.destroyCluster.serialize(writer));
        if (this.hasListServers)
            writer.writeMessage(13, this.listServers, () => this.listServers.serialize(writer));
        if (this.hasListServerLogs)
            writer.writeMessage(14, this.listServerLogs, () => this.listServerLogs.serialize(writer));
        if (this.hasListClusterLogs)
            writer.writeMessage(15, this.listClusterLogs, () => this.listClusterLogs.serialize(writer));
        if (this.hasSetupCluster)
            writer.writeMessage(16, this.setupCluster, () => this.setupCluster.serialize(writer));
        if (this.hasCreateDatabase)
            writer.writeMessage(17, this.createDatabase, () => this.createDatabase.serialize(writer));
        if (this.hasLoadSampleDataset)
            writer.writeMessage(18, this.loadSampleDataset, () => this.loadSampleDataset.serialize(writer));
        if (this.hasGetClusterStorageUsage)
            writer.writeMessage(19, this.getClusterStorageUsage, () => this.getClusterStorageUsage.serialize(writer));
        if (this.hasTakeSnapshot)
            writer.writeMessage(20, this.takeSnapshot, () => this.takeSnapshot.serialize(writer));
        if (this.hasRestoreCluster)
            writer.writeMessage(21, this.restoreCluster, () => this.restoreCluster.serialize(writer));
        if (this.hasListSnapshots)
            writer.writeMessage(22, this.listSnapshots, () => this.listSnapshots.serialize(writer));
        if (this.hasDeleteSnapshot)
            writer.writeMessage(23, this.deleteSnapshot, () => this.deleteSnapshot.serialize(writer));
        if (this.hasCheckClusterAutoPause)
            writer.writeMessage(24, this.checkClusterAutoPause, () => this.checkClusterAutoPause.serialize(writer));
        if (this.hasMarkClusterAsActive)
            writer.writeMessage(25, this.markClusterAsActive, () => this.markClusterAsActive.serialize(writer));
        if (this.hasCloneCluster)
            writer.writeMessage(26, this.cloneCluster, () => this.cloneCluster.serialize(writer));
        if (this.hasResetUserPassword)
            writer.writeMessage(27, this.resetUserPassword, () => this.resetUserPassword.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.getAccessLevels, () => message.getAccessLevels = ClusterCtlProtoGetAccessLevelsReq.deserialize(reader));
                    break;
                case 2:
                    reader.readMessage(message.getLatestCompatibleTypedb, () => message.getLatestCompatibleTypedb = ClusterCtlProtoGetLatestCompatibleTypeDBReq.deserialize(reader));
                    break;
                case 3:
                    reader.readMessage(message.getClusterDeploymentOptions, () => message.getClusterDeploymentOptions = ClusterCtlProtoGetClusterDeploymentOptionsReq.deserialize(reader));
                    break;
                case 4:
                    reader.readMessage(message.getClusterPrice, () => message.getClusterPrice = ClusterCtlProtoGetClusterPriceReq.deserialize(reader));
                    break;
                case 5:
                    reader.readMessage(message.getClusterPresetPrice, () => message.getClusterPresetPrice = ClusterCtlProtoGetClusterPresetPriceReq.deserialize(reader));
                    break;
                case 6:
                    reader.readMessage(message.deployCluster, () => message.deployCluster = ClusterCtlProtoDeployClusterReq.deserialize(reader));
                    break;
                case 7:
                    reader.readMessage(message.getCluster, () => message.getCluster = ClusterCtlProtoGetClusterReq.deserialize(reader));
                    break;
                case 8:
                    reader.readMessage(message.updateCluster, () => message.updateCluster = ClusterCtlProtoUpdateClusterReq.deserialize(reader));
                    break;
                case 9:
                    reader.readMessage(message.updateToLatestCompatibleTypedb, () => message.updateToLatestCompatibleTypedb = ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq.deserialize(reader));
                    break;
                case 10:
                    reader.readMessage(message.pauseCluster, () => message.pauseCluster = ClusterCtlProtoPauseClusterReq.deserialize(reader));
                    break;
                case 11:
                    reader.readMessage(message.resumeCluster, () => message.resumeCluster = ClusterCtlProtoResumeClusterReq.deserialize(reader));
                    break;
                case 12:
                    reader.readMessage(message.destroyCluster, () => message.destroyCluster = ClusterCtlProtoDestroyClusterReq.deserialize(reader));
                    break;
                case 13:
                    reader.readMessage(message.listServers, () => message.listServers = ClusterCtlProtoListServersReq.deserialize(reader));
                    break;
                case 14:
                    reader.readMessage(message.listServerLogs, () => message.listServerLogs = ClusterCtlProtoListServerLogsReq.deserialize(reader));
                    break;
                case 15:
                    reader.readMessage(message.listClusterLogs, () => message.listClusterLogs = ClusterCtlProtoListClusterLogsReq.deserialize(reader));
                    break;
                case 16:
                    reader.readMessage(message.setupCluster, () => message.setupCluster = ClusterCtlProtoSetupClusterReq.deserialize(reader));
                    break;
                case 17:
                    reader.readMessage(message.createDatabase, () => message.createDatabase = ClusterCtlProtoCreateDatabaseReq.deserialize(reader));
                    break;
                case 18:
                    reader.readMessage(message.loadSampleDataset, () => message.loadSampleDataset = ClusterCtlProtoLoadSampleDatasetReq.deserialize(reader));
                    break;
                case 19:
                    reader.readMessage(message.getClusterStorageUsage, () => message.getClusterStorageUsage = ClusterCtlProtoGetClusterStorageUsageReq.deserialize(reader));
                    break;
                case 20:
                    reader.readMessage(message.takeSnapshot, () => message.takeSnapshot = ClusterCtlProtoTakeSnapshotReq.deserialize(reader));
                    break;
                case 21:
                    reader.readMessage(message.restoreCluster, () => message.restoreCluster = ClusterCtlProtoRestoreClusterReq.deserialize(reader));
                    break;
                case 22:
                    reader.readMessage(message.listSnapshots, () => message.listSnapshots = ClusterCtlProtoListSnapshotsReq.deserialize(reader));
                    break;
                case 23:
                    reader.readMessage(message.deleteSnapshot, () => message.deleteSnapshot = ClusterCtlProtoDeleteSnapshotReq.deserialize(reader));
                    break;
                case 24:
                    reader.readMessage(message.checkClusterAutoPause, () => message.checkClusterAutoPause = ClusterCtlProtoCheckClusterAutoPauseReq.deserialize(reader));
                    break;
                case 25:
                    reader.readMessage(message.markClusterAsActive, () => message.markClusterAsActive = ClusterCtlProtoMarkClusterAsActiveReq.deserialize(reader));
                    break;
                case 26:
                    reader.readMessage(message.cloneCluster, () => message.cloneCluster = ClusterCtlProtoCloneClusterReq.deserialize(reader));
                    break;
                case 27:
                    reader.readMessage(message.resetUserPassword, () => message.resetUserPassword = ClusterCtlProtoResetUserPasswordReq.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoReq {
        return ClusterCtlProtoReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoRes extends pb_1.Message {
    #one_of_decls: number[][] = [[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]];
    constructor(data?: any[] | ({} & (({
        getAccessLevels?: ClusterCtlProtoGetAccessLevelsRes;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        getCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        getClusterStorageUsage?: never;
        listSnapshots?: never;
        checkClusterAutoPause?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: ClusterCtlProtoGetLatestCompatibleTypeDBRes;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        getCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        getClusterStorageUsage?: never;
        listSnapshots?: never;
        checkClusterAutoPause?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: ClusterCtlProtoGetClusterDeploymentOptionsRes;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        getCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        getClusterStorageUsage?: never;
        listSnapshots?: never;
        checkClusterAutoPause?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: ClusterCtlProtoGetClusterPriceRes;
        getClusterPresetPrice?: never;
        getCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        getClusterStorageUsage?: never;
        listSnapshots?: never;
        checkClusterAutoPause?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: ClusterCtlProtoGetClusterPresetPriceRes;
        getCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        getClusterStorageUsage?: never;
        listSnapshots?: never;
        checkClusterAutoPause?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        getCluster?: ClusterCtlProtoGetClusterRes;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        getClusterStorageUsage?: never;
        listSnapshots?: never;
        checkClusterAutoPause?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        getCluster?: never;
        listServers?: ClusterCtlProtoListServersRes;
        listServerLogs?: never;
        listClusterLogs?: never;
        getClusterStorageUsage?: never;
        listSnapshots?: never;
        checkClusterAutoPause?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        getCluster?: never;
        listServers?: never;
        listServerLogs?: ClusterCtlProtoListServerLogsRes;
        listClusterLogs?: never;
        getClusterStorageUsage?: never;
        listSnapshots?: never;
        checkClusterAutoPause?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        getCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: ClusterCtlProtoListClusterLogsRes;
        getClusterStorageUsage?: never;
        listSnapshots?: never;
        checkClusterAutoPause?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        getCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        getClusterStorageUsage?: ClusterCtlProtoGetClusterStorageUsageRes;
        listSnapshots?: never;
        checkClusterAutoPause?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        getCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        getClusterStorageUsage?: never;
        listSnapshots?: ClusterCtlProtoListSnapshotsRes;
        checkClusterAutoPause?: never;
    } | {
        getAccessLevels?: never;
        getLatestCompatibleTypedb?: never;
        getClusterDeploymentOptions?: never;
        getClusterPrice?: never;
        getClusterPresetPrice?: never;
        getCluster?: never;
        listServers?: never;
        listServerLogs?: never;
        listClusterLogs?: never;
        getClusterStorageUsage?: never;
        listSnapshots?: never;
        checkClusterAutoPause?: ClusterCtlProtoCheckClusterAutoPauseRes;
    })))) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("getAccessLevels" in data && data.getAccessLevels != undefined) {
                this.getAccessLevels = data.getAccessLevels;
            }
            if ("getLatestCompatibleTypedb" in data && data.getLatestCompatibleTypedb != undefined) {
                this.getLatestCompatibleTypedb = data.getLatestCompatibleTypedb;
            }
            if ("getClusterDeploymentOptions" in data && data.getClusterDeploymentOptions != undefined) {
                this.getClusterDeploymentOptions = data.getClusterDeploymentOptions;
            }
            if ("getClusterPrice" in data && data.getClusterPrice != undefined) {
                this.getClusterPrice = data.getClusterPrice;
            }
            if ("getClusterPresetPrice" in data && data.getClusterPresetPrice != undefined) {
                this.getClusterPresetPrice = data.getClusterPresetPrice;
            }
            if ("getCluster" in data && data.getCluster != undefined) {
                this.getCluster = data.getCluster;
            }
            if ("listServers" in data && data.listServers != undefined) {
                this.listServers = data.listServers;
            }
            if ("listServerLogs" in data && data.listServerLogs != undefined) {
                this.listServerLogs = data.listServerLogs;
            }
            if ("listClusterLogs" in data && data.listClusterLogs != undefined) {
                this.listClusterLogs = data.listClusterLogs;
            }
            if ("getClusterStorageUsage" in data && data.getClusterStorageUsage != undefined) {
                this.getClusterStorageUsage = data.getClusterStorageUsage;
            }
            if ("listSnapshots" in data && data.listSnapshots != undefined) {
                this.listSnapshots = data.listSnapshots;
            }
            if ("checkClusterAutoPause" in data && data.checkClusterAutoPause != undefined) {
                this.checkClusterAutoPause = data.checkClusterAutoPause;
            }
        }
    }
    get getAccessLevels() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetAccessLevelsRes, 1) as ClusterCtlProtoGetAccessLevelsRes;
    }
    set getAccessLevels(value: ClusterCtlProtoGetAccessLevelsRes) {
        pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
    }
    get hasGetAccessLevels() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get getLatestCompatibleTypedb() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetLatestCompatibleTypeDBRes, 2) as ClusterCtlProtoGetLatestCompatibleTypeDBRes;
    }
    set getLatestCompatibleTypedb(value: ClusterCtlProtoGetLatestCompatibleTypeDBRes) {
        pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[0], value);
    }
    get hasGetLatestCompatibleTypedb() {
        return pb_1.Message.getField(this, 2) != null;
    }
    get getClusterDeploymentOptions() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetClusterDeploymentOptionsRes, 3) as ClusterCtlProtoGetClusterDeploymentOptionsRes;
    }
    set getClusterDeploymentOptions(value: ClusterCtlProtoGetClusterDeploymentOptionsRes) {
        pb_1.Message.setOneofWrapperField(this, 3, this.#one_of_decls[0], value);
    }
    get hasGetClusterDeploymentOptions() {
        return pb_1.Message.getField(this, 3) != null;
    }
    get getClusterPrice() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetClusterPriceRes, 4) as ClusterCtlProtoGetClusterPriceRes;
    }
    set getClusterPrice(value: ClusterCtlProtoGetClusterPriceRes) {
        pb_1.Message.setOneofWrapperField(this, 4, this.#one_of_decls[0], value);
    }
    get hasGetClusterPrice() {
        return pb_1.Message.getField(this, 4) != null;
    }
    get getClusterPresetPrice() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetClusterPresetPriceRes, 5) as ClusterCtlProtoGetClusterPresetPriceRes;
    }
    set getClusterPresetPrice(value: ClusterCtlProtoGetClusterPresetPriceRes) {
        pb_1.Message.setOneofWrapperField(this, 5, this.#one_of_decls[0], value);
    }
    get hasGetClusterPresetPrice() {
        return pb_1.Message.getField(this, 5) != null;
    }
    get getCluster() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetClusterRes, 6) as ClusterCtlProtoGetClusterRes;
    }
    set getCluster(value: ClusterCtlProtoGetClusterRes) {
        pb_1.Message.setOneofWrapperField(this, 6, this.#one_of_decls[0], value);
    }
    get hasGetCluster() {
        return pb_1.Message.getField(this, 6) != null;
    }
    get listServers() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoListServersRes, 7) as ClusterCtlProtoListServersRes;
    }
    set listServers(value: ClusterCtlProtoListServersRes) {
        pb_1.Message.setOneofWrapperField(this, 7, this.#one_of_decls[0], value);
    }
    get hasListServers() {
        return pb_1.Message.getField(this, 7) != null;
    }
    get listServerLogs() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoListServerLogsRes, 8) as ClusterCtlProtoListServerLogsRes;
    }
    set listServerLogs(value: ClusterCtlProtoListServerLogsRes) {
        pb_1.Message.setOneofWrapperField(this, 8, this.#one_of_decls[0], value);
    }
    get hasListServerLogs() {
        return pb_1.Message.getField(this, 8) != null;
    }
    get listClusterLogs() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoListClusterLogsRes, 9) as ClusterCtlProtoListClusterLogsRes;
    }
    set listClusterLogs(value: ClusterCtlProtoListClusterLogsRes) {
        pb_1.Message.setOneofWrapperField(this, 9, this.#one_of_decls[0], value);
    }
    get hasListClusterLogs() {
        return pb_1.Message.getField(this, 9) != null;
    }
    get getClusterStorageUsage() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoGetClusterStorageUsageRes, 10) as ClusterCtlProtoGetClusterStorageUsageRes;
    }
    set getClusterStorageUsage(value: ClusterCtlProtoGetClusterStorageUsageRes) {
        pb_1.Message.setOneofWrapperField(this, 10, this.#one_of_decls[0], value);
    }
    get hasGetClusterStorageUsage() {
        return pb_1.Message.getField(this, 10) != null;
    }
    get listSnapshots() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoListSnapshotsRes, 11) as ClusterCtlProtoListSnapshotsRes;
    }
    set listSnapshots(value: ClusterCtlProtoListSnapshotsRes) {
        pb_1.Message.setOneofWrapperField(this, 11, this.#one_of_decls[0], value);
    }
    get hasListSnapshots() {
        return pb_1.Message.getField(this, 11) != null;
    }
    get checkClusterAutoPause() {
        return pb_1.Message.getWrapperField(this, ClusterCtlProtoCheckClusterAutoPauseRes, 12) as ClusterCtlProtoCheckClusterAutoPauseRes;
    }
    set checkClusterAutoPause(value: ClusterCtlProtoCheckClusterAutoPauseRes) {
        pb_1.Message.setOneofWrapperField(this, 12, this.#one_of_decls[0], value);
    }
    get hasCheckClusterAutoPause() {
        return pb_1.Message.getField(this, 12) != null;
    }
    get res() {
        const cases: {
            [index: number]: "none" | "getAccessLevels" | "getLatestCompatibleTypedb" | "getClusterDeploymentOptions" | "getClusterPrice" | "getClusterPresetPrice" | "getCluster" | "listServers" | "listServerLogs" | "listClusterLogs" | "getClusterStorageUsage" | "listSnapshots" | "checkClusterAutoPause";
        } = {
            0: "none",
            1: "getAccessLevels",
            2: "getLatestCompatibleTypedb",
            3: "getClusterDeploymentOptions",
            4: "getClusterPrice",
            5: "getClusterPresetPrice",
            6: "getCluster",
            7: "listServers",
            8: "listServerLogs",
            9: "listClusterLogs",
            10: "getClusterStorageUsage",
            11: "listSnapshots",
            12: "checkClusterAutoPause"
        };
        return cases[pb_1.Message.computeOneofCase(this, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])];
    }
    static fromObject(data: {
        getAccessLevels?: ReturnType<typeof ClusterCtlProtoGetAccessLevelsRes.prototype.toObject>;
        getLatestCompatibleTypedb?: ReturnType<typeof ClusterCtlProtoGetLatestCompatibleTypeDBRes.prototype.toObject>;
        getClusterDeploymentOptions?: ReturnType<typeof ClusterCtlProtoGetClusterDeploymentOptionsRes.prototype.toObject>;
        getClusterPrice?: ReturnType<typeof ClusterCtlProtoGetClusterPriceRes.prototype.toObject>;
        getClusterPresetPrice?: ReturnType<typeof ClusterCtlProtoGetClusterPresetPriceRes.prototype.toObject>;
        getCluster?: ReturnType<typeof ClusterCtlProtoGetClusterRes.prototype.toObject>;
        listServers?: ReturnType<typeof ClusterCtlProtoListServersRes.prototype.toObject>;
        listServerLogs?: ReturnType<typeof ClusterCtlProtoListServerLogsRes.prototype.toObject>;
        listClusterLogs?: ReturnType<typeof ClusterCtlProtoListClusterLogsRes.prototype.toObject>;
        getClusterStorageUsage?: ReturnType<typeof ClusterCtlProtoGetClusterStorageUsageRes.prototype.toObject>;
        listSnapshots?: ReturnType<typeof ClusterCtlProtoListSnapshotsRes.prototype.toObject>;
        checkClusterAutoPause?: ReturnType<typeof ClusterCtlProtoCheckClusterAutoPauseRes.prototype.toObject>;
    }): ClusterCtlProtoRes {
        const message = new ClusterCtlProtoRes({});
        if (data.getAccessLevels != null) {
            message.getAccessLevels = ClusterCtlProtoGetAccessLevelsRes.fromObject(data.getAccessLevels);
        }
        if (data.getLatestCompatibleTypedb != null) {
            message.getLatestCompatibleTypedb = ClusterCtlProtoGetLatestCompatibleTypeDBRes.fromObject(data.getLatestCompatibleTypedb);
        }
        if (data.getClusterDeploymentOptions != null) {
            message.getClusterDeploymentOptions = ClusterCtlProtoGetClusterDeploymentOptionsRes.fromObject(data.getClusterDeploymentOptions);
        }
        if (data.getClusterPrice != null) {
            message.getClusterPrice = ClusterCtlProtoGetClusterPriceRes.fromObject(data.getClusterPrice);
        }
        if (data.getClusterPresetPrice != null) {
            message.getClusterPresetPrice = ClusterCtlProtoGetClusterPresetPriceRes.fromObject(data.getClusterPresetPrice);
        }
        if (data.getCluster != null) {
            message.getCluster = ClusterCtlProtoGetClusterRes.fromObject(data.getCluster);
        }
        if (data.listServers != null) {
            message.listServers = ClusterCtlProtoListServersRes.fromObject(data.listServers);
        }
        if (data.listServerLogs != null) {
            message.listServerLogs = ClusterCtlProtoListServerLogsRes.fromObject(data.listServerLogs);
        }
        if (data.listClusterLogs != null) {
            message.listClusterLogs = ClusterCtlProtoListClusterLogsRes.fromObject(data.listClusterLogs);
        }
        if (data.getClusterStorageUsage != null) {
            message.getClusterStorageUsage = ClusterCtlProtoGetClusterStorageUsageRes.fromObject(data.getClusterStorageUsage);
        }
        if (data.listSnapshots != null) {
            message.listSnapshots = ClusterCtlProtoListSnapshotsRes.fromObject(data.listSnapshots);
        }
        if (data.checkClusterAutoPause != null) {
            message.checkClusterAutoPause = ClusterCtlProtoCheckClusterAutoPauseRes.fromObject(data.checkClusterAutoPause);
        }
        return message;
    }
    toObject() {
        const data: {
            getAccessLevels?: ReturnType<typeof ClusterCtlProtoGetAccessLevelsRes.prototype.toObject>;
            getLatestCompatibleTypedb?: ReturnType<typeof ClusterCtlProtoGetLatestCompatibleTypeDBRes.prototype.toObject>;
            getClusterDeploymentOptions?: ReturnType<typeof ClusterCtlProtoGetClusterDeploymentOptionsRes.prototype.toObject>;
            getClusterPrice?: ReturnType<typeof ClusterCtlProtoGetClusterPriceRes.prototype.toObject>;
            getClusterPresetPrice?: ReturnType<typeof ClusterCtlProtoGetClusterPresetPriceRes.prototype.toObject>;
            getCluster?: ReturnType<typeof ClusterCtlProtoGetClusterRes.prototype.toObject>;
            listServers?: ReturnType<typeof ClusterCtlProtoListServersRes.prototype.toObject>;
            listServerLogs?: ReturnType<typeof ClusterCtlProtoListServerLogsRes.prototype.toObject>;
            listClusterLogs?: ReturnType<typeof ClusterCtlProtoListClusterLogsRes.prototype.toObject>;
            getClusterStorageUsage?: ReturnType<typeof ClusterCtlProtoGetClusterStorageUsageRes.prototype.toObject>;
            listSnapshots?: ReturnType<typeof ClusterCtlProtoListSnapshotsRes.prototype.toObject>;
            checkClusterAutoPause?: ReturnType<typeof ClusterCtlProtoCheckClusterAutoPauseRes.prototype.toObject>;
        } = {};
        if (this.getAccessLevels != null) {
            data.getAccessLevels = this.getAccessLevels.toObject();
        }
        if (this.getLatestCompatibleTypedb != null) {
            data.getLatestCompatibleTypedb = this.getLatestCompatibleTypedb.toObject();
        }
        if (this.getClusterDeploymentOptions != null) {
            data.getClusterDeploymentOptions = this.getClusterDeploymentOptions.toObject();
        }
        if (this.getClusterPrice != null) {
            data.getClusterPrice = this.getClusterPrice.toObject();
        }
        if (this.getClusterPresetPrice != null) {
            data.getClusterPresetPrice = this.getClusterPresetPrice.toObject();
        }
        if (this.getCluster != null) {
            data.getCluster = this.getCluster.toObject();
        }
        if (this.listServers != null) {
            data.listServers = this.listServers.toObject();
        }
        if (this.listServerLogs != null) {
            data.listServerLogs = this.listServerLogs.toObject();
        }
        if (this.listClusterLogs != null) {
            data.listClusterLogs = this.listClusterLogs.toObject();
        }
        if (this.getClusterStorageUsage != null) {
            data.getClusterStorageUsage = this.getClusterStorageUsage.toObject();
        }
        if (this.listSnapshots != null) {
            data.listSnapshots = this.listSnapshots.toObject();
        }
        if (this.checkClusterAutoPause != null) {
            data.checkClusterAutoPause = this.checkClusterAutoPause.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.hasGetAccessLevels)
            writer.writeMessage(1, this.getAccessLevels, () => this.getAccessLevels.serialize(writer));
        if (this.hasGetLatestCompatibleTypedb)
            writer.writeMessage(2, this.getLatestCompatibleTypedb, () => this.getLatestCompatibleTypedb.serialize(writer));
        if (this.hasGetClusterDeploymentOptions)
            writer.writeMessage(3, this.getClusterDeploymentOptions, () => this.getClusterDeploymentOptions.serialize(writer));
        if (this.hasGetClusterPrice)
            writer.writeMessage(4, this.getClusterPrice, () => this.getClusterPrice.serialize(writer));
        if (this.hasGetClusterPresetPrice)
            writer.writeMessage(5, this.getClusterPresetPrice, () => this.getClusterPresetPrice.serialize(writer));
        if (this.hasGetCluster)
            writer.writeMessage(6, this.getCluster, () => this.getCluster.serialize(writer));
        if (this.hasListServers)
            writer.writeMessage(7, this.listServers, () => this.listServers.serialize(writer));
        if (this.hasListServerLogs)
            writer.writeMessage(8, this.listServerLogs, () => this.listServerLogs.serialize(writer));
        if (this.hasListClusterLogs)
            writer.writeMessage(9, this.listClusterLogs, () => this.listClusterLogs.serialize(writer));
        if (this.hasGetClusterStorageUsage)
            writer.writeMessage(10, this.getClusterStorageUsage, () => this.getClusterStorageUsage.serialize(writer));
        if (this.hasListSnapshots)
            writer.writeMessage(11, this.listSnapshots, () => this.listSnapshots.serialize(writer));
        if (this.hasCheckClusterAutoPause)
            writer.writeMessage(12, this.checkClusterAutoPause, () => this.checkClusterAutoPause.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoRes {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoRes();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.getAccessLevels, () => message.getAccessLevels = ClusterCtlProtoGetAccessLevelsRes.deserialize(reader));
                    break;
                case 2:
                    reader.readMessage(message.getLatestCompatibleTypedb, () => message.getLatestCompatibleTypedb = ClusterCtlProtoGetLatestCompatibleTypeDBRes.deserialize(reader));
                    break;
                case 3:
                    reader.readMessage(message.getClusterDeploymentOptions, () => message.getClusterDeploymentOptions = ClusterCtlProtoGetClusterDeploymentOptionsRes.deserialize(reader));
                    break;
                case 4:
                    reader.readMessage(message.getClusterPrice, () => message.getClusterPrice = ClusterCtlProtoGetClusterPriceRes.deserialize(reader));
                    break;
                case 5:
                    reader.readMessage(message.getClusterPresetPrice, () => message.getClusterPresetPrice = ClusterCtlProtoGetClusterPresetPriceRes.deserialize(reader));
                    break;
                case 6:
                    reader.readMessage(message.getCluster, () => message.getCluster = ClusterCtlProtoGetClusterRes.deserialize(reader));
                    break;
                case 7:
                    reader.readMessage(message.listServers, () => message.listServers = ClusterCtlProtoListServersRes.deserialize(reader));
                    break;
                case 8:
                    reader.readMessage(message.listServerLogs, () => message.listServerLogs = ClusterCtlProtoListServerLogsRes.deserialize(reader));
                    break;
                case 9:
                    reader.readMessage(message.listClusterLogs, () => message.listClusterLogs = ClusterCtlProtoListClusterLogsRes.deserialize(reader));
                    break;
                case 10:
                    reader.readMessage(message.getClusterStorageUsage, () => message.getClusterStorageUsage = ClusterCtlProtoGetClusterStorageUsageRes.deserialize(reader));
                    break;
                case 11:
                    reader.readMessage(message.listSnapshots, () => message.listSnapshots = ClusterCtlProtoListSnapshotsRes.deserialize(reader));
                    break;
                case 12:
                    reader.readMessage(message.checkClusterAutoPause, () => message.checkClusterAutoPause = ClusterCtlProtoCheckClusterAutoPauseRes.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoRes {
        return ClusterCtlProtoRes.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetAccessLevels extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoGetAccessLevels {
        const message = new ClusterCtlProtoGetAccessLevels({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetAccessLevels {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetAccessLevels();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetAccessLevels {
        return ClusterCtlProtoGetAccessLevels.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetAccessLevelsReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuids?: Uint8Array[];
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuids" in data && data.clusterUuids != undefined) {
                this.clusterUuids = data.clusterUuids;
            }
        }
    }
    get clusterUuids() {
        return pb_1.Message.getFieldWithDefault(this, 1, []) as Uint8Array[];
    }
    set clusterUuids(value: Uint8Array[]) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        clusterUuids?: Uint8Array[];
    }): ClusterCtlProtoGetAccessLevelsReq {
        const message = new ClusterCtlProtoGetAccessLevelsReq({});
        if (data.clusterUuids != null) {
            message.clusterUuids = data.clusterUuids;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuids?: Uint8Array[];
        } = {};
        if (this.clusterUuids != null) {
            data.clusterUuids = this.clusterUuids;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuids.length)
            writer.writeRepeatedBytes(1, this.clusterUuids);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetAccessLevelsReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetAccessLevelsReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    pb_1.Message.addToRepeatedField(message, 1, reader.readBytes());
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetAccessLevelsReq {
        return ClusterCtlProtoGetAccessLevelsReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetAccessLevelsRes extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        accessLevels?: dependency_1.AccessLevelProto[];
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("accessLevels" in data && data.accessLevels != undefined) {
                this.accessLevels = data.accessLevels;
            }
        }
    }
    get accessLevels() {
        return pb_1.Message.getFieldWithDefault(this, 1, []) as dependency_1.AccessLevelProto[];
    }
    set accessLevels(value: dependency_1.AccessLevelProto[]) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        accessLevels?: dependency_1.AccessLevelProto[];
    }): ClusterCtlProtoGetAccessLevelsRes {
        const message = new ClusterCtlProtoGetAccessLevelsRes({});
        if (data.accessLevels != null) {
            message.accessLevels = data.accessLevels;
        }
        return message;
    }
    toObject() {
        const data: {
            accessLevels?: dependency_1.AccessLevelProto[];
        } = {};
        if (this.accessLevels != null) {
            data.accessLevels = this.accessLevels;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.accessLevels.length)
            writer.writePackedEnum(1, this.accessLevels);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetAccessLevelsRes {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetAccessLevelsRes();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.accessLevels = reader.readPackedEnum();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetAccessLevelsRes {
        return ClusterCtlProtoGetAccessLevelsRes.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterDeploymentOptions extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoGetClusterDeploymentOptions {
        const message = new ClusterCtlProtoGetClusterDeploymentOptions({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterDeploymentOptions {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterDeploymentOptions();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterDeploymentOptions {
        return ClusterCtlProtoGetClusterDeploymentOptions.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterDeploymentOptionsReq extends pb_1.Message {
    #one_of_decls: number[][] = [[1], [2]];
    constructor(data?: any[] | ({
        teamUuid?: Uint8Array;
    } & (({
        providerId?: string;
    }) | ({
        regionId?: string;
    })))) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("providerId" in data && data.providerId != undefined) {
                this.providerId = data.providerId;
            }
            if ("regionId" in data && data.regionId != undefined) {
                this.regionId = data.regionId;
            }
            if ("teamUuid" in data && data.teamUuid != undefined) {
                this.teamUuid = data.teamUuid;
            }
        }
    }
    get providerId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
    }
    set providerId(value: string) {
        pb_1.Message.setOneofField(this, 1, this.#one_of_decls[0], value);
    }
    get hasProviderId() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get regionId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
    }
    set regionId(value: string) {
        pb_1.Message.setOneofField(this, 2, this.#one_of_decls[1], value);
    }
    get hasRegionId() {
        return pb_1.Message.getField(this, 2) != null;
    }
    get teamUuid() {
        return pb_1.Message.getFieldWithDefault(this, 3, new Uint8Array(0)) as Uint8Array;
    }
    set teamUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 3, value);
    }
    get _provider_id() {
        const cases: {
            [index: number]: "none" | "providerId";
        } = {
            0: "none",
            1: "providerId"
        };
        return cases[pb_1.Message.computeOneofCase(this, [1])];
    }
    get _region_id() {
        const cases: {
            [index: number]: "none" | "regionId";
        } = {
            0: "none",
            2: "regionId"
        };
        return cases[pb_1.Message.computeOneofCase(this, [2])];
    }
    static fromObject(data: {
        providerId?: string;
        regionId?: string;
        teamUuid?: Uint8Array;
    }): ClusterCtlProtoGetClusterDeploymentOptionsReq {
        const message = new ClusterCtlProtoGetClusterDeploymentOptionsReq({});
        if (data.providerId != null) {
            message.providerId = data.providerId;
        }
        if (data.regionId != null) {
            message.regionId = data.regionId;
        }
        if (data.teamUuid != null) {
            message.teamUuid = data.teamUuid;
        }
        return message;
    }
    toObject() {
        const data: {
            providerId?: string;
            regionId?: string;
            teamUuid?: Uint8Array;
        } = {};
        if (this.providerId != null) {
            data.providerId = this.providerId;
        }
        if (this.regionId != null) {
            data.regionId = this.regionId;
        }
        if (this.teamUuid != null) {
            data.teamUuid = this.teamUuid;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.hasProviderId)
            writer.writeString(1, this.providerId);
        if (this.hasRegionId)
            writer.writeString(2, this.regionId);
        if (this.teamUuid.length)
            writer.writeBytes(3, this.teamUuid);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterDeploymentOptionsReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterDeploymentOptionsReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.providerId = reader.readString();
                    break;
                case 2:
                    message.regionId = reader.readString();
                    break;
                case 3:
                    message.teamUuid = reader.readBytes();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterDeploymentOptionsReq {
        return ClusterCtlProtoGetClusterDeploymentOptionsReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterDeploymentOptionsRes extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        gcp?: dependency_1.ProviderProto;
        aws?: dependency_1.ProviderProto;
        azure?: dependency_1.ProviderProto;
        typedbVersions?: dependency_1.TypeDBVersionProto[];
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("gcp" in data && data.gcp != undefined) {
                this.gcp = data.gcp;
            }
            if ("aws" in data && data.aws != undefined) {
                this.aws = data.aws;
            }
            if ("azure" in data && data.azure != undefined) {
                this.azure = data.azure;
            }
            if ("typedbVersions" in data && data.typedbVersions != undefined) {
                this.typedbVersions = data.typedbVersions;
            }
        }
    }
    get gcp() {
        return pb_1.Message.getWrapperField(this, dependency_1.ProviderProto, 1) as dependency_1.ProviderProto;
    }
    set gcp(value: dependency_1.ProviderProto) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get hasGcp() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get aws() {
        return pb_1.Message.getWrapperField(this, dependency_1.ProviderProto, 2) as dependency_1.ProviderProto;
    }
    set aws(value: dependency_1.ProviderProto) {
        pb_1.Message.setWrapperField(this, 2, value);
    }
    get hasAws() {
        return pb_1.Message.getField(this, 2) != null;
    }
    get azure() {
        return pb_1.Message.getWrapperField(this, dependency_1.ProviderProto, 3) as dependency_1.ProviderProto;
    }
    set azure(value: dependency_1.ProviderProto) {
        pb_1.Message.setWrapperField(this, 3, value);
    }
    get hasAzure() {
        return pb_1.Message.getField(this, 3) != null;
    }
    get typedbVersions() {
        return pb_1.Message.getRepeatedWrapperField(this, dependency_1.TypeDBVersionProto, 4) as dependency_1.TypeDBVersionProto[];
    }
    set typedbVersions(value: dependency_1.TypeDBVersionProto[]) {
        pb_1.Message.setRepeatedWrapperField(this, 4, value);
    }
    static fromObject(data: {
        gcp?: ReturnType<typeof dependency_1.ProviderProto.prototype.toObject>;
        aws?: ReturnType<typeof dependency_1.ProviderProto.prototype.toObject>;
        azure?: ReturnType<typeof dependency_1.ProviderProto.prototype.toObject>;
        typedbVersions?: ReturnType<typeof dependency_1.TypeDBVersionProto.prototype.toObject>[];
    }): ClusterCtlProtoGetClusterDeploymentOptionsRes {
        const message = new ClusterCtlProtoGetClusterDeploymentOptionsRes({});
        if (data.gcp != null) {
            message.gcp = dependency_1.ProviderProto.fromObject(data.gcp);
        }
        if (data.aws != null) {
            message.aws = dependency_1.ProviderProto.fromObject(data.aws);
        }
        if (data.azure != null) {
            message.azure = dependency_1.ProviderProto.fromObject(data.azure);
        }
        if (data.typedbVersions != null) {
            message.typedbVersions = data.typedbVersions.map(item => dependency_1.TypeDBVersionProto.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data: {
            gcp?: ReturnType<typeof dependency_1.ProviderProto.prototype.toObject>;
            aws?: ReturnType<typeof dependency_1.ProviderProto.prototype.toObject>;
            azure?: ReturnType<typeof dependency_1.ProviderProto.prototype.toObject>;
            typedbVersions?: ReturnType<typeof dependency_1.TypeDBVersionProto.prototype.toObject>[];
        } = {};
        if (this.gcp != null) {
            data.gcp = this.gcp.toObject();
        }
        if (this.aws != null) {
            data.aws = this.aws.toObject();
        }
        if (this.azure != null) {
            data.azure = this.azure.toObject();
        }
        if (this.typedbVersions != null) {
            data.typedbVersions = this.typedbVersions.map((item: dependency_1.TypeDBVersionProto) => item.toObject());
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.hasGcp)
            writer.writeMessage(1, this.gcp, () => this.gcp.serialize(writer));
        if (this.hasAws)
            writer.writeMessage(2, this.aws, () => this.aws.serialize(writer));
        if (this.hasAzure)
            writer.writeMessage(3, this.azure, () => this.azure.serialize(writer));
        if (this.typedbVersions.length)
            writer.writeRepeatedMessage(4, this.typedbVersions, (item: dependency_1.TypeDBVersionProto) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterDeploymentOptionsRes {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterDeploymentOptionsRes();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.gcp, () => message.gcp = dependency_1.ProviderProto.deserialize(reader));
                    break;
                case 2:
                    reader.readMessage(message.aws, () => message.aws = dependency_1.ProviderProto.deserialize(reader));
                    break;
                case 3:
                    reader.readMessage(message.azure, () => message.azure = dependency_1.ProviderProto.deserialize(reader));
                    break;
                case 4:
                    reader.readMessage(message.typedbVersions, () => pb_1.Message.addToRepeatedWrapperField(message, 4, dependency_1.TypeDBVersionProto.deserialize(reader), dependency_1.TypeDBVersionProto));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterDeploymentOptionsRes {
        return ClusterCtlProtoGetClusterDeploymentOptionsRes.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterPrice extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoGetClusterPrice {
        const message = new ClusterCtlProtoGetClusterPrice({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterPrice {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterPrice();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterPrice {
        return ClusterCtlProtoGetClusterPrice.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterPriceReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        teamUuid?: Uint8Array;
        cluster?: dependency_1.ClusterProto;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("teamUuid" in data && data.teamUuid != undefined) {
                this.teamUuid = data.teamUuid;
            }
            if ("cluster" in data && data.cluster != undefined) {
                this.cluster = data.cluster;
            }
        }
    }
    get teamUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set teamUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    get cluster() {
        return pb_1.Message.getWrapperField(this, dependency_1.ClusterProto, 2) as dependency_1.ClusterProto;
    }
    set cluster(value: dependency_1.ClusterProto) {
        pb_1.Message.setWrapperField(this, 2, value);
    }
    get hasCluster() {
        return pb_1.Message.getField(this, 2) != null;
    }
    static fromObject(data: {
        teamUuid?: Uint8Array;
        cluster?: ReturnType<typeof dependency_1.ClusterProto.prototype.toObject>;
    }): ClusterCtlProtoGetClusterPriceReq {
        const message = new ClusterCtlProtoGetClusterPriceReq({});
        if (data.teamUuid != null) {
            message.teamUuid = data.teamUuid;
        }
        if (data.cluster != null) {
            message.cluster = dependency_1.ClusterProto.fromObject(data.cluster);
        }
        return message;
    }
    toObject() {
        const data: {
            teamUuid?: Uint8Array;
            cluster?: ReturnType<typeof dependency_1.ClusterProto.prototype.toObject>;
        } = {};
        if (this.teamUuid != null) {
            data.teamUuid = this.teamUuid;
        }
        if (this.cluster != null) {
            data.cluster = this.cluster.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.teamUuid.length)
            writer.writeBytes(1, this.teamUuid);
        if (this.hasCluster)
            writer.writeMessage(2, this.cluster, () => this.cluster.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterPriceReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterPriceReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.teamUuid = reader.readBytes();
                    break;
                case 2:
                    reader.readMessage(message.cluster, () => message.cluster = dependency_1.ClusterProto.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterPriceReq {
        return ClusterCtlProtoGetClusterPriceReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterPriceRes extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        price?: dependency_1.ClusterPriceProto;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("price" in data && data.price != undefined) {
                this.price = data.price;
            }
        }
    }
    get price() {
        return pb_1.Message.getWrapperField(this, dependency_1.ClusterPriceProto, 1) as dependency_1.ClusterPriceProto;
    }
    set price(value: dependency_1.ClusterPriceProto) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get hasPrice() {
        return pb_1.Message.getField(this, 1) != null;
    }
    static fromObject(data: {
        price?: ReturnType<typeof dependency_1.ClusterPriceProto.prototype.toObject>;
    }): ClusterCtlProtoGetClusterPriceRes {
        const message = new ClusterCtlProtoGetClusterPriceRes({});
        if (data.price != null) {
            message.price = dependency_1.ClusterPriceProto.fromObject(data.price);
        }
        return message;
    }
    toObject() {
        const data: {
            price?: ReturnType<typeof dependency_1.ClusterPriceProto.prototype.toObject>;
        } = {};
        if (this.price != null) {
            data.price = this.price.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.hasPrice)
            writer.writeMessage(1, this.price, () => this.price.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterPriceRes {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterPriceRes();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.price, () => message.price = dependency_1.ClusterPriceProto.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterPriceRes {
        return ClusterCtlProtoGetClusterPriceRes.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterPresetPrice extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoGetClusterPresetPrice {
        const message = new ClusterCtlProtoGetClusterPresetPrice({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterPresetPrice {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterPresetPrice();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterPresetPrice {
        return ClusterCtlProtoGetClusterPresetPrice.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterPresetPriceReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        teamUuid?: Uint8Array;
        regionId?: string;
        presetId?: string;
        getForSingleNode?: boolean;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("teamUuid" in data && data.teamUuid != undefined) {
                this.teamUuid = data.teamUuid;
            }
            if ("regionId" in data && data.regionId != undefined) {
                this.regionId = data.regionId;
            }
            if ("presetId" in data && data.presetId != undefined) {
                this.presetId = data.presetId;
            }
            if ("getForSingleNode" in data && data.getForSingleNode != undefined) {
                this.getForSingleNode = data.getForSingleNode;
            }
        }
    }
    get teamUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set teamUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    get regionId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
    }
    set regionId(value: string) {
        pb_1.Message.setField(this, 2, value);
    }
    get presetId() {
        return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
    }
    set presetId(value: string) {
        pb_1.Message.setField(this, 3, value);
    }
    get getForSingleNode() {
        return pb_1.Message.getFieldWithDefault(this, 4, false) as boolean;
    }
    set getForSingleNode(value: boolean) {
        pb_1.Message.setField(this, 4, value);
    }
    static fromObject(data: {
        teamUuid?: Uint8Array;
        regionId?: string;
        presetId?: string;
        getForSingleNode?: boolean;
    }): ClusterCtlProtoGetClusterPresetPriceReq {
        const message = new ClusterCtlProtoGetClusterPresetPriceReq({});
        if (data.teamUuid != null) {
            message.teamUuid = data.teamUuid;
        }
        if (data.regionId != null) {
            message.regionId = data.regionId;
        }
        if (data.presetId != null) {
            message.presetId = data.presetId;
        }
        if (data.getForSingleNode != null) {
            message.getForSingleNode = data.getForSingleNode;
        }
        return message;
    }
    toObject() {
        const data: {
            teamUuid?: Uint8Array;
            regionId?: string;
            presetId?: string;
            getForSingleNode?: boolean;
        } = {};
        if (this.teamUuid != null) {
            data.teamUuid = this.teamUuid;
        }
        if (this.regionId != null) {
            data.regionId = this.regionId;
        }
        if (this.presetId != null) {
            data.presetId = this.presetId;
        }
        if (this.getForSingleNode != null) {
            data.getForSingleNode = this.getForSingleNode;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.teamUuid.length)
            writer.writeBytes(1, this.teamUuid);
        if (this.regionId.length)
            writer.writeString(2, this.regionId);
        if (this.presetId.length)
            writer.writeString(3, this.presetId);
        if (this.getForSingleNode != false)
            writer.writeBool(4, this.getForSingleNode);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterPresetPriceReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterPresetPriceReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.teamUuid = reader.readBytes();
                    break;
                case 2:
                    message.regionId = reader.readString();
                    break;
                case 3:
                    message.presetId = reader.readString();
                    break;
                case 4:
                    message.getForSingleNode = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterPresetPriceReq {
        return ClusterCtlProtoGetClusterPresetPriceReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterPresetPriceRes extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        price?: dependency_1.ClusterPriceProto;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("price" in data && data.price != undefined) {
                this.price = data.price;
            }
        }
    }
    get price() {
        return pb_1.Message.getWrapperField(this, dependency_1.ClusterPriceProto, 1) as dependency_1.ClusterPriceProto;
    }
    set price(value: dependency_1.ClusterPriceProto) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get hasPrice() {
        return pb_1.Message.getField(this, 1) != null;
    }
    static fromObject(data: {
        price?: ReturnType<typeof dependency_1.ClusterPriceProto.prototype.toObject>;
    }): ClusterCtlProtoGetClusterPresetPriceRes {
        const message = new ClusterCtlProtoGetClusterPresetPriceRes({});
        if (data.price != null) {
            message.price = dependency_1.ClusterPriceProto.fromObject(data.price);
        }
        return message;
    }
    toObject() {
        const data: {
            price?: ReturnType<typeof dependency_1.ClusterPriceProto.prototype.toObject>;
        } = {};
        if (this.price != null) {
            data.price = this.price.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.hasPrice)
            writer.writeMessage(1, this.price, () => this.price.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterPresetPriceRes {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterPresetPriceRes();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.price, () => message.price = dependency_1.ClusterPriceProto.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterPresetPriceRes {
        return ClusterCtlProtoGetClusterPresetPriceRes.deserialize(bytes);
    }
}
export class ClusterCtlProtoDeployCluster extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoDeployCluster {
        const message = new ClusterCtlProtoDeployCluster({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoDeployCluster {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoDeployCluster();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoDeployCluster {
        return ClusterCtlProtoDeployCluster.deserialize(bytes);
    }
}
export class ClusterCtlProtoDeployClusterReq extends pb_1.Message {
    #one_of_decls: number[][] = [[2]];
    constructor(data?: any[] | ({
        cluster?: dependency_1.ClusterProto;
    } & (({
        createFromSnapshot?: string;
    })))) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("cluster" in data && data.cluster != undefined) {
                this.cluster = data.cluster;
            }
            if ("createFromSnapshot" in data && data.createFromSnapshot != undefined) {
                this.createFromSnapshot = data.createFromSnapshot;
            }
        }
    }
    get cluster() {
        return pb_1.Message.getWrapperField(this, dependency_1.ClusterProto, 1) as dependency_1.ClusterProto;
    }
    set cluster(value: dependency_1.ClusterProto) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get hasCluster() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get createFromSnapshot() {
        return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
    }
    set createFromSnapshot(value: string) {
        pb_1.Message.setOneofField(this, 2, this.#one_of_decls[0], value);
    }
    get hasCreateFromSnapshot() {
        return pb_1.Message.getField(this, 2) != null;
    }
    get _create_from_snapshot() {
        const cases: {
            [index: number]: "none" | "createFromSnapshot";
        } = {
            0: "none",
            2: "createFromSnapshot"
        };
        return cases[pb_1.Message.computeOneofCase(this, [2])];
    }
    static fromObject(data: {
        cluster?: ReturnType<typeof dependency_1.ClusterProto.prototype.toObject>;
        createFromSnapshot?: string;
    }): ClusterCtlProtoDeployClusterReq {
        const message = new ClusterCtlProtoDeployClusterReq({});
        if (data.cluster != null) {
            message.cluster = dependency_1.ClusterProto.fromObject(data.cluster);
        }
        if (data.createFromSnapshot != null) {
            message.createFromSnapshot = data.createFromSnapshot;
        }
        return message;
    }
    toObject() {
        const data: {
            cluster?: ReturnType<typeof dependency_1.ClusterProto.prototype.toObject>;
            createFromSnapshot?: string;
        } = {};
        if (this.cluster != null) {
            data.cluster = this.cluster.toObject();
        }
        if (this.createFromSnapshot != null) {
            data.createFromSnapshot = this.createFromSnapshot;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.hasCluster)
            writer.writeMessage(1, this.cluster, () => this.cluster.serialize(writer));
        if (this.hasCreateFromSnapshot)
            writer.writeString(2, this.createFromSnapshot);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoDeployClusterReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoDeployClusterReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.cluster, () => message.cluster = dependency_1.ClusterProto.deserialize(reader));
                    break;
                case 2:
                    message.createFromSnapshot = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoDeployClusterReq {
        return ClusterCtlProtoDeployClusterReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoTakeSnapshot extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoTakeSnapshot {
        const message = new ClusterCtlProtoTakeSnapshot({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoTakeSnapshot {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoTakeSnapshot();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoTakeSnapshot {
        return ClusterCtlProtoTakeSnapshot.deserialize(bytes);
    }
}
export class ClusterCtlProtoTakeSnapshotReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
    }): ClusterCtlProtoTakeSnapshotReq {
        const message = new ClusterCtlProtoTakeSnapshotReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoTakeSnapshotReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoTakeSnapshotReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoTakeSnapshotReq {
        return ClusterCtlProtoTakeSnapshotReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoRestoreCluster extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoRestoreCluster {
        const message = new ClusterCtlProtoRestoreCluster({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoRestoreCluster {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoRestoreCluster();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoRestoreCluster {
        return ClusterCtlProtoRestoreCluster.deserialize(bytes);
    }
}
export class ClusterCtlProtoRestoreClusterReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
        snapshotId?: string;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
            if ("snapshotId" in data && data.snapshotId != undefined) {
                this.snapshotId = data.snapshotId;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    get snapshotId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
    }
    set snapshotId(value: string) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
        snapshotId?: string;
    }): ClusterCtlProtoRestoreClusterReq {
        const message = new ClusterCtlProtoRestoreClusterReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        if (data.snapshotId != null) {
            message.snapshotId = data.snapshotId;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
            snapshotId?: string;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        if (this.snapshotId != null) {
            data.snapshotId = this.snapshotId;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (this.snapshotId.length)
            writer.writeString(2, this.snapshotId);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoRestoreClusterReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoRestoreClusterReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                case 2:
                    message.snapshotId = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoRestoreClusterReq {
        return ClusterCtlProtoRestoreClusterReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoListSnapshots extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoListSnapshots {
        const message = new ClusterCtlProtoListSnapshots({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoListSnapshots {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoListSnapshots();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoListSnapshots {
        return ClusterCtlProtoListSnapshots.deserialize(bytes);
    }
}
export class ClusterCtlProtoListSnapshotsReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
    }): ClusterCtlProtoListSnapshotsReq {
        const message = new ClusterCtlProtoListSnapshotsReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoListSnapshotsReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoListSnapshotsReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoListSnapshotsReq {
        return ClusterCtlProtoListSnapshotsReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoListSnapshotsRes extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        snapshot?: dependency_1.ClusterProtoSnapshot[];
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("snapshot" in data && data.snapshot != undefined) {
                this.snapshot = data.snapshot;
            }
        }
    }
    get snapshot() {
        return pb_1.Message.getRepeatedWrapperField(this, dependency_1.ClusterProtoSnapshot, 1) as dependency_1.ClusterProtoSnapshot[];
    }
    set snapshot(value: dependency_1.ClusterProtoSnapshot[]) {
        pb_1.Message.setRepeatedWrapperField(this, 1, value);
    }
    static fromObject(data: {
        snapshot?: ReturnType<typeof dependency_1.ClusterProtoSnapshot.prototype.toObject>[];
    }): ClusterCtlProtoListSnapshotsRes {
        const message = new ClusterCtlProtoListSnapshotsRes({});
        if (data.snapshot != null) {
            message.snapshot = data.snapshot.map(item => dependency_1.ClusterProtoSnapshot.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data: {
            snapshot?: ReturnType<typeof dependency_1.ClusterProtoSnapshot.prototype.toObject>[];
        } = {};
        if (this.snapshot != null) {
            data.snapshot = this.snapshot.map((item: dependency_1.ClusterProtoSnapshot) => item.toObject());
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.snapshot.length)
            writer.writeRepeatedMessage(1, this.snapshot, (item: dependency_1.ClusterProtoSnapshot) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoListSnapshotsRes {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoListSnapshotsRes();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.snapshot, () => pb_1.Message.addToRepeatedWrapperField(message, 1, dependency_1.ClusterProtoSnapshot.deserialize(reader), dependency_1.ClusterProtoSnapshot));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoListSnapshotsRes {
        return ClusterCtlProtoListSnapshotsRes.deserialize(bytes);
    }
}
export class ClusterCtlProtoDeleteSnapshot extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoDeleteSnapshot {
        const message = new ClusterCtlProtoDeleteSnapshot({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoDeleteSnapshot {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoDeleteSnapshot();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoDeleteSnapshot {
        return ClusterCtlProtoDeleteSnapshot.deserialize(bytes);
    }
}
export class ClusterCtlProtoDeleteSnapshotReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
        snapshotId?: string;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
            if ("snapshotId" in data && data.snapshotId != undefined) {
                this.snapshotId = data.snapshotId;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    get snapshotId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
    }
    set snapshotId(value: string) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
        snapshotId?: string;
    }): ClusterCtlProtoDeleteSnapshotReq {
        const message = new ClusterCtlProtoDeleteSnapshotReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        if (data.snapshotId != null) {
            message.snapshotId = data.snapshotId;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
            snapshotId?: string;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        if (this.snapshotId != null) {
            data.snapshotId = this.snapshotId;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (this.snapshotId.length)
            writer.writeString(2, this.snapshotId);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoDeleteSnapshotReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoDeleteSnapshotReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                case 2:
                    message.snapshotId = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoDeleteSnapshotReq {
        return ClusterCtlProtoDeleteSnapshotReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetCluster extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoGetCluster {
        const message = new ClusterCtlProtoGetCluster({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetCluster {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetCluster();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetCluster {
        return ClusterCtlProtoGetCluster.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        spaceUuid?: Uint8Array;
        clusterId?: string;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("spaceUuid" in data && data.spaceUuid != undefined) {
                this.spaceUuid = data.spaceUuid;
            }
            if ("clusterId" in data && data.clusterId != undefined) {
                this.clusterId = data.clusterId;
            }
        }
    }
    get spaceUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set spaceUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    get clusterId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
    }
    set clusterId(value: string) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data: {
        spaceUuid?: Uint8Array;
        clusterId?: string;
    }): ClusterCtlProtoGetClusterReq {
        const message = new ClusterCtlProtoGetClusterReq({});
        if (data.spaceUuid != null) {
            message.spaceUuid = data.spaceUuid;
        }
        if (data.clusterId != null) {
            message.clusterId = data.clusterId;
        }
        return message;
    }
    toObject() {
        const data: {
            spaceUuid?: Uint8Array;
            clusterId?: string;
        } = {};
        if (this.spaceUuid != null) {
            data.spaceUuid = this.spaceUuid;
        }
        if (this.clusterId != null) {
            data.clusterId = this.clusterId;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.spaceUuid.length)
            writer.writeBytes(1, this.spaceUuid);
        if (this.clusterId.length)
            writer.writeString(2, this.clusterId);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.spaceUuid = reader.readBytes();
                    break;
                case 2:
                    message.clusterId = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterReq {
        return ClusterCtlProtoGetClusterReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterRes extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        cluster?: dependency_1.ClusterProto;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("cluster" in data && data.cluster != undefined) {
                this.cluster = data.cluster;
            }
        }
    }
    get cluster() {
        return pb_1.Message.getWrapperField(this, dependency_1.ClusterProto, 1) as dependency_1.ClusterProto;
    }
    set cluster(value: dependency_1.ClusterProto) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get hasCluster() {
        return pb_1.Message.getField(this, 1) != null;
    }
    static fromObject(data: {
        cluster?: ReturnType<typeof dependency_1.ClusterProto.prototype.toObject>;
    }): ClusterCtlProtoGetClusterRes {
        const message = new ClusterCtlProtoGetClusterRes({});
        if (data.cluster != null) {
            message.cluster = dependency_1.ClusterProto.fromObject(data.cluster);
        }
        return message;
    }
    toObject() {
        const data: {
            cluster?: ReturnType<typeof dependency_1.ClusterProto.prototype.toObject>;
        } = {};
        if (this.cluster != null) {
            data.cluster = this.cluster.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.hasCluster)
            writer.writeMessage(1, this.cluster, () => this.cluster.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterRes {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterRes();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.cluster, () => message.cluster = dependency_1.ClusterProto.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterRes {
        return ClusterCtlProtoGetClusterRes.deserialize(bytes);
    }
}
export class ClusterCtlProtoUpdateCluster extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoUpdateCluster {
        const message = new ClusterCtlProtoUpdateCluster({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoUpdateCluster {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoUpdateCluster();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoUpdateCluster {
        return ClusterCtlProtoUpdateCluster.deserialize(bytes);
    }
}
export class ClusterCtlProtoUpdateClusterReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        cluster?: dependency_1.ClusterProto;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("cluster" in data && data.cluster != undefined) {
                this.cluster = data.cluster;
            }
        }
    }
    get cluster() {
        return pb_1.Message.getWrapperField(this, dependency_1.ClusterProto, 1) as dependency_1.ClusterProto;
    }
    set cluster(value: dependency_1.ClusterProto) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get hasCluster() {
        return pb_1.Message.getField(this, 1) != null;
    }
    static fromObject(data: {
        cluster?: ReturnType<typeof dependency_1.ClusterProto.prototype.toObject>;
    }): ClusterCtlProtoUpdateClusterReq {
        const message = new ClusterCtlProtoUpdateClusterReq({});
        if (data.cluster != null) {
            message.cluster = dependency_1.ClusterProto.fromObject(data.cluster);
        }
        return message;
    }
    toObject() {
        const data: {
            cluster?: ReturnType<typeof dependency_1.ClusterProto.prototype.toObject>;
        } = {};
        if (this.cluster != null) {
            data.cluster = this.cluster.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.hasCluster)
            writer.writeMessage(1, this.cluster, () => this.cluster.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoUpdateClusterReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoUpdateClusterReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.cluster, () => message.cluster = dependency_1.ClusterProto.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoUpdateClusterReq {
        return ClusterCtlProtoUpdateClusterReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoUpdateToLatestCompatibleTypeDB extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoUpdateToLatestCompatibleTypeDB {
        const message = new ClusterCtlProtoUpdateToLatestCompatibleTypeDB({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoUpdateToLatestCompatibleTypeDB {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoUpdateToLatestCompatibleTypeDB();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoUpdateToLatestCompatibleTypeDB {
        return ClusterCtlProtoUpdateToLatestCompatibleTypeDB.deserialize(bytes);
    }
}
export class ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
    }): ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq {
        const message = new ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq {
        return ClusterCtlProtoUpdateToLatestCompatibleTypeDBReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoPauseCluster extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoPauseCluster {
        const message = new ClusterCtlProtoPauseCluster({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoPauseCluster {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoPauseCluster();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoPauseCluster {
        return ClusterCtlProtoPauseCluster.deserialize(bytes);
    }
}
export class ClusterCtlProtoPauseClusterReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
    }): ClusterCtlProtoPauseClusterReq {
        const message = new ClusterCtlProtoPauseClusterReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoPauseClusterReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoPauseClusterReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoPauseClusterReq {
        return ClusterCtlProtoPauseClusterReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoResumeCluster extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoResumeCluster {
        const message = new ClusterCtlProtoResumeCluster({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoResumeCluster {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoResumeCluster();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoResumeCluster {
        return ClusterCtlProtoResumeCluster.deserialize(bytes);
    }
}
export class ClusterCtlProtoResumeClusterReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
    }): ClusterCtlProtoResumeClusterReq {
        const message = new ClusterCtlProtoResumeClusterReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoResumeClusterReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoResumeClusterReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoResumeClusterReq {
        return ClusterCtlProtoResumeClusterReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoDestroyCluster extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoDestroyCluster {
        const message = new ClusterCtlProtoDestroyCluster({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoDestroyCluster {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoDestroyCluster();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoDestroyCluster {
        return ClusterCtlProtoDestroyCluster.deserialize(bytes);
    }
}
export class ClusterCtlProtoDestroyClusterReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
    }): ClusterCtlProtoDestroyClusterReq {
        const message = new ClusterCtlProtoDestroyClusterReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoDestroyClusterReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoDestroyClusterReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoDestroyClusterReq {
        return ClusterCtlProtoDestroyClusterReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoListServers extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoListServers {
        const message = new ClusterCtlProtoListServers({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoListServers {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoListServers();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoListServers {
        return ClusterCtlProtoListServers.deserialize(bytes);
    }
}
export class ClusterCtlProtoListServersReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
    }): ClusterCtlProtoListServersReq {
        const message = new ClusterCtlProtoListServersReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoListServersReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoListServersReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoListServersReq {
        return ClusterCtlProtoListServersReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoListServersRes extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        servers?: dependency_1.ClusterProtoServer[];
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("servers" in data && data.servers != undefined) {
                this.servers = data.servers;
            }
        }
    }
    get servers() {
        return pb_1.Message.getRepeatedWrapperField(this, dependency_1.ClusterProtoServer, 1) as dependency_1.ClusterProtoServer[];
    }
    set servers(value: dependency_1.ClusterProtoServer[]) {
        pb_1.Message.setRepeatedWrapperField(this, 1, value);
    }
    static fromObject(data: {
        servers?: ReturnType<typeof dependency_1.ClusterProtoServer.prototype.toObject>[];
    }): ClusterCtlProtoListServersRes {
        const message = new ClusterCtlProtoListServersRes({});
        if (data.servers != null) {
            message.servers = data.servers.map(item => dependency_1.ClusterProtoServer.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data: {
            servers?: ReturnType<typeof dependency_1.ClusterProtoServer.prototype.toObject>[];
        } = {};
        if (this.servers != null) {
            data.servers = this.servers.map((item: dependency_1.ClusterProtoServer) => item.toObject());
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.servers.length)
            writer.writeRepeatedMessage(1, this.servers, (item: dependency_1.ClusterProtoServer) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoListServersRes {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoListServersRes();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.servers, () => pb_1.Message.addToRepeatedWrapperField(message, 1, dependency_1.ClusterProtoServer.deserialize(reader), dependency_1.ClusterProtoServer));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoListServersRes {
        return ClusterCtlProtoListServersRes.deserialize(bytes);
    }
}
export class ClusterCtlProtoListServerLogs extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoListServerLogs {
        const message = new ClusterCtlProtoListServerLogs({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoListServerLogs {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoListServerLogs();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoListServerLogs {
        return ClusterCtlProtoListServerLogs.deserialize(bytes);
    }
}
export class ClusterCtlProtoListServerLogsReq extends pb_1.Message {
    #one_of_decls: number[][] = [[4]];
    constructor(data?: any[] | ({
        clusterUuid?: Uint8Array;
        serverUuid?: Uint8Array;
        serverIndex?: number;
        snapshot?: boolean;
    } & (({
        initialLineCount?: number;
    })))) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
            if ("serverUuid" in data && data.serverUuid != undefined) {
                this.serverUuid = data.serverUuid;
            }
            if ("serverIndex" in data && data.serverIndex != undefined) {
                this.serverIndex = data.serverIndex;
            }
            if ("initialLineCount" in data && data.initialLineCount != undefined) {
                this.initialLineCount = data.initialLineCount;
            }
            if ("snapshot" in data && data.snapshot != undefined) {
                this.snapshot = data.snapshot;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    get serverUuid() {
        return pb_1.Message.getFieldWithDefault(this, 2, new Uint8Array(0)) as Uint8Array;
    }
    set serverUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 2, value);
    }
    get serverIndex() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
    }
    set serverIndex(value: number) {
        pb_1.Message.setField(this, 3, value);
    }
    get initialLineCount() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
    }
    set initialLineCount(value: number) {
        pb_1.Message.setOneofField(this, 4, this.#one_of_decls[0], value);
    }
    get hasInitialLineCount() {
        return pb_1.Message.getField(this, 4) != null;
    }
    get snapshot() {
        return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
    }
    set snapshot(value: boolean) {
        pb_1.Message.setField(this, 5, value);
    }
    get _initial_line_count() {
        const cases: {
            [index: number]: "none" | "initialLineCount";
        } = {
            0: "none",
            4: "initialLineCount"
        };
        return cases[pb_1.Message.computeOneofCase(this, [4])];
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
        serverUuid?: Uint8Array;
        serverIndex?: number;
        initialLineCount?: number;
        snapshot?: boolean;
    }): ClusterCtlProtoListServerLogsReq {
        const message = new ClusterCtlProtoListServerLogsReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        if (data.serverUuid != null) {
            message.serverUuid = data.serverUuid;
        }
        if (data.serverIndex != null) {
            message.serverIndex = data.serverIndex;
        }
        if (data.initialLineCount != null) {
            message.initialLineCount = data.initialLineCount;
        }
        if (data.snapshot != null) {
            message.snapshot = data.snapshot;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
            serverUuid?: Uint8Array;
            serverIndex?: number;
            initialLineCount?: number;
            snapshot?: boolean;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        if (this.serverUuid != null) {
            data.serverUuid = this.serverUuid;
        }
        if (this.serverIndex != null) {
            data.serverIndex = this.serverIndex;
        }
        if (this.initialLineCount != null) {
            data.initialLineCount = this.initialLineCount;
        }
        if (this.snapshot != null) {
            data.snapshot = this.snapshot;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (this.serverUuid.length)
            writer.writeBytes(2, this.serverUuid);
        if (this.serverIndex != 0)
            writer.writeInt32(3, this.serverIndex);
        if (this.hasInitialLineCount)
            writer.writeInt32(4, this.initialLineCount);
        if (this.snapshot != false)
            writer.writeBool(5, this.snapshot);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoListServerLogsReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoListServerLogsReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                case 2:
                    message.serverUuid = reader.readBytes();
                    break;
                case 3:
                    message.serverIndex = reader.readInt32();
                    break;
                case 4:
                    message.initialLineCount = reader.readInt32();
                    break;
                case 5:
                    message.snapshot = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoListServerLogsReq {
        return ClusterCtlProtoListServerLogsReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoListServerLogsRes extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        logBatch?: dependency_1.ClusterProtoServerLogBatch;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("logBatch" in data && data.logBatch != undefined) {
                this.logBatch = data.logBatch;
            }
        }
    }
    get logBatch() {
        return pb_1.Message.getWrapperField(this, dependency_1.ClusterProtoServerLogBatch, 1) as dependency_1.ClusterProtoServerLogBatch;
    }
    set logBatch(value: dependency_1.ClusterProtoServerLogBatch) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get hasLogBatch() {
        return pb_1.Message.getField(this, 1) != null;
    }
    static fromObject(data: {
        logBatch?: ReturnType<typeof dependency_1.ClusterProtoServerLogBatch.prototype.toObject>;
    }): ClusterCtlProtoListServerLogsRes {
        const message = new ClusterCtlProtoListServerLogsRes({});
        if (data.logBatch != null) {
            message.logBatch = dependency_1.ClusterProtoServerLogBatch.fromObject(data.logBatch);
        }
        return message;
    }
    toObject() {
        const data: {
            logBatch?: ReturnType<typeof dependency_1.ClusterProtoServerLogBatch.prototype.toObject>;
        } = {};
        if (this.logBatch != null) {
            data.logBatch = this.logBatch.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.hasLogBatch)
            writer.writeMessage(1, this.logBatch, () => this.logBatch.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoListServerLogsRes {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoListServerLogsRes();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.logBatch, () => message.logBatch = dependency_1.ClusterProtoServerLogBatch.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoListServerLogsRes {
        return ClusterCtlProtoListServerLogsRes.deserialize(bytes);
    }
}
export class ClusterCtlProtoListClusterLogs extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoListClusterLogs {
        const message = new ClusterCtlProtoListClusterLogs({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoListClusterLogs {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoListClusterLogs();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoListClusterLogs {
        return ClusterCtlProtoListClusterLogs.deserialize(bytes);
    }
}
export class ClusterCtlProtoListClusterLogsReq extends pb_1.Message {
    #one_of_decls: number[][] = [[2]];
    constructor(data?: any[] | ({
        clusterUuid?: Uint8Array;
        snapshot?: boolean;
    } & (({
        initialLineCount?: number;
    })))) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
            if ("initialLineCount" in data && data.initialLineCount != undefined) {
                this.initialLineCount = data.initialLineCount;
            }
            if ("snapshot" in data && data.snapshot != undefined) {
                this.snapshot = data.snapshot;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    get initialLineCount() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
    }
    set initialLineCount(value: number) {
        pb_1.Message.setOneofField(this, 2, this.#one_of_decls[0], value);
    }
    get hasInitialLineCount() {
        return pb_1.Message.getField(this, 2) != null;
    }
    get snapshot() {
        return pb_1.Message.getFieldWithDefault(this, 3, false) as boolean;
    }
    set snapshot(value: boolean) {
        pb_1.Message.setField(this, 3, value);
    }
    get _initial_line_count() {
        const cases: {
            [index: number]: "none" | "initialLineCount";
        } = {
            0: "none",
            2: "initialLineCount"
        };
        return cases[pb_1.Message.computeOneofCase(this, [2])];
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
        initialLineCount?: number;
        snapshot?: boolean;
    }): ClusterCtlProtoListClusterLogsReq {
        const message = new ClusterCtlProtoListClusterLogsReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        if (data.initialLineCount != null) {
            message.initialLineCount = data.initialLineCount;
        }
        if (data.snapshot != null) {
            message.snapshot = data.snapshot;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
            initialLineCount?: number;
            snapshot?: boolean;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        if (this.initialLineCount != null) {
            data.initialLineCount = this.initialLineCount;
        }
        if (this.snapshot != null) {
            data.snapshot = this.snapshot;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (this.hasInitialLineCount)
            writer.writeInt32(2, this.initialLineCount);
        if (this.snapshot != false)
            writer.writeBool(3, this.snapshot);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoListClusterLogsReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoListClusterLogsReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                case 2:
                    message.initialLineCount = reader.readInt32();
                    break;
                case 3:
                    message.snapshot = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoListClusterLogsReq {
        return ClusterCtlProtoListClusterLogsReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoListClusterLogsRes extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        logBatch?: dependency_1.ClusterProtoLogBatch;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("logBatch" in data && data.logBatch != undefined) {
                this.logBatch = data.logBatch;
            }
        }
    }
    get logBatch() {
        return pb_1.Message.getWrapperField(this, dependency_1.ClusterProtoLogBatch, 1) as dependency_1.ClusterProtoLogBatch;
    }
    set logBatch(value: dependency_1.ClusterProtoLogBatch) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get hasLogBatch() {
        return pb_1.Message.getField(this, 1) != null;
    }
    static fromObject(data: {
        logBatch?: ReturnType<typeof dependency_1.ClusterProtoLogBatch.prototype.toObject>;
    }): ClusterCtlProtoListClusterLogsRes {
        const message = new ClusterCtlProtoListClusterLogsRes({});
        if (data.logBatch != null) {
            message.logBatch = dependency_1.ClusterProtoLogBatch.fromObject(data.logBatch);
        }
        return message;
    }
    toObject() {
        const data: {
            logBatch?: ReturnType<typeof dependency_1.ClusterProtoLogBatch.prototype.toObject>;
        } = {};
        if (this.logBatch != null) {
            data.logBatch = this.logBatch.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.hasLogBatch)
            writer.writeMessage(1, this.logBatch, () => this.logBatch.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoListClusterLogsRes {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoListClusterLogsRes();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.logBatch, () => message.logBatch = dependency_1.ClusterProtoLogBatch.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoListClusterLogsRes {
        return ClusterCtlProtoListClusterLogsRes.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetLatestCompatibleTypeDB extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoGetLatestCompatibleTypeDB {
        const message = new ClusterCtlProtoGetLatestCompatibleTypeDB({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetLatestCompatibleTypeDB {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetLatestCompatibleTypeDB();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetLatestCompatibleTypeDB {
        return ClusterCtlProtoGetLatestCompatibleTypeDB.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetLatestCompatibleTypeDBReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        typedbVersion?: string;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("typedbVersion" in data && data.typedbVersion != undefined) {
                this.typedbVersion = data.typedbVersion;
            }
        }
    }
    get typedbVersion() {
        return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
    }
    set typedbVersion(value: string) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        typedbVersion?: string;
    }): ClusterCtlProtoGetLatestCompatibleTypeDBReq {
        const message = new ClusterCtlProtoGetLatestCompatibleTypeDBReq({});
        if (data.typedbVersion != null) {
            message.typedbVersion = data.typedbVersion;
        }
        return message;
    }
    toObject() {
        const data: {
            typedbVersion?: string;
        } = {};
        if (this.typedbVersion != null) {
            data.typedbVersion = this.typedbVersion;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.typedbVersion.length)
            writer.writeString(1, this.typedbVersion);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetLatestCompatibleTypeDBReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetLatestCompatibleTypeDBReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.typedbVersion = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetLatestCompatibleTypeDBReq {
        return ClusterCtlProtoGetLatestCompatibleTypeDBReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetLatestCompatibleTypeDBRes extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        typedbVersion?: string;
        migrationRequired?: boolean;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("typedbVersion" in data && data.typedbVersion != undefined) {
                this.typedbVersion = data.typedbVersion;
            }
            if ("migrationRequired" in data && data.migrationRequired != undefined) {
                this.migrationRequired = data.migrationRequired;
            }
        }
    }
    get typedbVersion() {
        return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
    }
    set typedbVersion(value: string) {
        pb_1.Message.setField(this, 1, value);
    }
    get migrationRequired() {
        return pb_1.Message.getFieldWithDefault(this, 2, false) as boolean;
    }
    set migrationRequired(value: boolean) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data: {
        typedbVersion?: string;
        migrationRequired?: boolean;
    }): ClusterCtlProtoGetLatestCompatibleTypeDBRes {
        const message = new ClusterCtlProtoGetLatestCompatibleTypeDBRes({});
        if (data.typedbVersion != null) {
            message.typedbVersion = data.typedbVersion;
        }
        if (data.migrationRequired != null) {
            message.migrationRequired = data.migrationRequired;
        }
        return message;
    }
    toObject() {
        const data: {
            typedbVersion?: string;
            migrationRequired?: boolean;
        } = {};
        if (this.typedbVersion != null) {
            data.typedbVersion = this.typedbVersion;
        }
        if (this.migrationRequired != null) {
            data.migrationRequired = this.migrationRequired;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.typedbVersion.length)
            writer.writeString(1, this.typedbVersion);
        if (this.migrationRequired != false)
            writer.writeBool(2, this.migrationRequired);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetLatestCompatibleTypeDBRes {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetLatestCompatibleTypeDBRes();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.typedbVersion = reader.readString();
                    break;
                case 2:
                    message.migrationRequired = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetLatestCompatibleTypeDBRes {
        return ClusterCtlProtoGetLatestCompatibleTypeDBRes.deserialize(bytes);
    }
}
export class ClusterCtlProtoSetupCluster extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoSetupCluster {
        const message = new ClusterCtlProtoSetupCluster({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoSetupCluster {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoSetupCluster();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoSetupCluster {
        return ClusterCtlProtoSetupCluster.deserialize(bytes);
    }
}
export class ClusterCtlProtoSetupClusterReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
        password?: string;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
            if ("password" in data && data.password != undefined) {
                this.password = data.password;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    get password() {
        return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
    }
    set password(value: string) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
        password?: string;
    }): ClusterCtlProtoSetupClusterReq {
        const message = new ClusterCtlProtoSetupClusterReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        if (data.password != null) {
            message.password = data.password;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
            password?: string;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        if (this.password != null) {
            data.password = this.password;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (this.password.length)
            writer.writeString(2, this.password);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoSetupClusterReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoSetupClusterReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                case 2:
                    message.password = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoSetupClusterReq {
        return ClusterCtlProtoSetupClusterReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoCreateDatabase extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoCreateDatabase {
        const message = new ClusterCtlProtoCreateDatabase({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoCreateDatabase {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoCreateDatabase();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoCreateDatabase {
        return ClusterCtlProtoCreateDatabase.deserialize(bytes);
    }
}
export class ClusterCtlProtoCreateDatabaseReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
        username?: string;
        password?: string;
        name?: string;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
            if ("username" in data && data.username != undefined) {
                this.username = data.username;
            }
            if ("password" in data && data.password != undefined) {
                this.password = data.password;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    get username() {
        return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
    }
    set username(value: string) {
        pb_1.Message.setField(this, 2, value);
    }
    get password() {
        return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
    }
    set password(value: string) {
        pb_1.Message.setField(this, 3, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
    }
    set name(value: string) {
        pb_1.Message.setField(this, 4, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
        username?: string;
        password?: string;
        name?: string;
    }): ClusterCtlProtoCreateDatabaseReq {
        const message = new ClusterCtlProtoCreateDatabaseReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        if (data.username != null) {
            message.username = data.username;
        }
        if (data.password != null) {
            message.password = data.password;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
            username?: string;
            password?: string;
            name?: string;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        if (this.username != null) {
            data.username = this.username;
        }
        if (this.password != null) {
            data.password = this.password;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (this.username.length)
            writer.writeString(2, this.username);
        if (this.password.length)
            writer.writeString(3, this.password);
        if (this.name.length)
            writer.writeString(4, this.name);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoCreateDatabaseReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoCreateDatabaseReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                case 2:
                    message.username = reader.readString();
                    break;
                case 3:
                    message.password = reader.readString();
                    break;
                case 4:
                    message.name = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoCreateDatabaseReq {
        return ClusterCtlProtoCreateDatabaseReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoLoadSampleDataset extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoLoadSampleDataset {
        const message = new ClusterCtlProtoLoadSampleDataset({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoLoadSampleDataset {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoLoadSampleDataset();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoLoadSampleDataset {
        return ClusterCtlProtoLoadSampleDataset.deserialize(bytes);
    }
}
export class ClusterCtlProtoLoadSampleDatasetReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
        username?: string;
        password?: string;
        database?: string;
        name?: string;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
            if ("username" in data && data.username != undefined) {
                this.username = data.username;
            }
            if ("password" in data && data.password != undefined) {
                this.password = data.password;
            }
            if ("database" in data && data.database != undefined) {
                this.database = data.database;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    get username() {
        return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
    }
    set username(value: string) {
        pb_1.Message.setField(this, 2, value);
    }
    get password() {
        return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
    }
    set password(value: string) {
        pb_1.Message.setField(this, 3, value);
    }
    get database() {
        return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
    }
    set database(value: string) {
        pb_1.Message.setField(this, 4, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
    }
    set name(value: string) {
        pb_1.Message.setField(this, 5, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
        username?: string;
        password?: string;
        database?: string;
        name?: string;
    }): ClusterCtlProtoLoadSampleDatasetReq {
        const message = new ClusterCtlProtoLoadSampleDatasetReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        if (data.username != null) {
            message.username = data.username;
        }
        if (data.password != null) {
            message.password = data.password;
        }
        if (data.database != null) {
            message.database = data.database;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
            username?: string;
            password?: string;
            database?: string;
            name?: string;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        if (this.username != null) {
            data.username = this.username;
        }
        if (this.password != null) {
            data.password = this.password;
        }
        if (this.database != null) {
            data.database = this.database;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (this.username.length)
            writer.writeString(2, this.username);
        if (this.password.length)
            writer.writeString(3, this.password);
        if (this.database.length)
            writer.writeString(4, this.database);
        if (this.name.length)
            writer.writeString(5, this.name);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoLoadSampleDatasetReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoLoadSampleDatasetReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                case 2:
                    message.username = reader.readString();
                    break;
                case 3:
                    message.password = reader.readString();
                    break;
                case 4:
                    message.database = reader.readString();
                    break;
                case 5:
                    message.name = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoLoadSampleDatasetReq {
        return ClusterCtlProtoLoadSampleDatasetReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterStorageUsage extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoGetClusterStorageUsage {
        const message = new ClusterCtlProtoGetClusterStorageUsage({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterStorageUsage {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterStorageUsage();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterStorageUsage {
        return ClusterCtlProtoGetClusterStorageUsage.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterStorageUsageReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
    }): ClusterCtlProtoGetClusterStorageUsageReq {
        const message = new ClusterCtlProtoGetClusterStorageUsageReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterStorageUsageReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterStorageUsageReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterStorageUsageReq {
        return ClusterCtlProtoGetClusterStorageUsageReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoGetClusterStorageUsageRes extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        bytesUsed?: number[];
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("bytesUsed" in data && data.bytesUsed != undefined) {
                this.bytesUsed = data.bytesUsed;
            }
        }
    }
    get bytesUsed() {
        return pb_1.Message.getFieldWithDefault(this, 1, []) as number[];
    }
    set bytesUsed(value: number[]) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        bytesUsed?: number[];
    }): ClusterCtlProtoGetClusterStorageUsageRes {
        const message = new ClusterCtlProtoGetClusterStorageUsageRes({});
        if (data.bytesUsed != null) {
            message.bytesUsed = data.bytesUsed;
        }
        return message;
    }
    toObject() {
        const data: {
            bytesUsed?: number[];
        } = {};
        if (this.bytesUsed != null) {
            data.bytesUsed = this.bytesUsed;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.bytesUsed.length)
            writer.writePackedUint64(1, this.bytesUsed);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoGetClusterStorageUsageRes {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoGetClusterStorageUsageRes();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.bytesUsed = reader.readPackedUint64();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoGetClusterStorageUsageRes {
        return ClusterCtlProtoGetClusterStorageUsageRes.deserialize(bytes);
    }
}
export class ClusterCtlProtoCheckClusterAutoPause extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoCheckClusterAutoPause {
        const message = new ClusterCtlProtoCheckClusterAutoPause({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoCheckClusterAutoPause {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoCheckClusterAutoPause();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoCheckClusterAutoPause {
        return ClusterCtlProtoCheckClusterAutoPause.deserialize(bytes);
    }
}
export class ClusterCtlProtoCheckClusterAutoPauseReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
    }): ClusterCtlProtoCheckClusterAutoPauseReq {
        const message = new ClusterCtlProtoCheckClusterAutoPauseReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoCheckClusterAutoPauseReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoCheckClusterAutoPauseReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoCheckClusterAutoPauseReq {
        return ClusterCtlProtoCheckClusterAutoPauseReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoCheckClusterAutoPauseRes extends pb_1.Message {
    #one_of_decls: number[][] = [[1], [2]];
    constructor(data?: any[] | ({
        autoPaused?: boolean;
    } & (({
        pauseDueAt?: number;
    }) | ({
        inactiveSince?: number;
    })))) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("pauseDueAt" in data && data.pauseDueAt != undefined) {
                this.pauseDueAt = data.pauseDueAt;
            }
            if ("inactiveSince" in data && data.inactiveSince != undefined) {
                this.inactiveSince = data.inactiveSince;
            }
            if ("autoPaused" in data && data.autoPaused != undefined) {
                this.autoPaused = data.autoPaused;
            }
        }
    }
    get pauseDueAt() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
    }
    set pauseDueAt(value: number) {
        pb_1.Message.setOneofField(this, 1, this.#one_of_decls[0], value);
    }
    get hasPauseDueAt() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get inactiveSince() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
    }
    set inactiveSince(value: number) {
        pb_1.Message.setOneofField(this, 2, this.#one_of_decls[1], value);
    }
    get hasInactiveSince() {
        return pb_1.Message.getField(this, 2) != null;
    }
    get autoPaused() {
        return pb_1.Message.getFieldWithDefault(this, 3, false) as boolean;
    }
    set autoPaused(value: boolean) {
        pb_1.Message.setField(this, 3, value);
    }
    get _pause_due_at() {
        const cases: {
            [index: number]: "none" | "pauseDueAt";
        } = {
            0: "none",
            1: "pauseDueAt"
        };
        return cases[pb_1.Message.computeOneofCase(this, [1])];
    }
    get _inactive_since() {
        const cases: {
            [index: number]: "none" | "inactiveSince";
        } = {
            0: "none",
            2: "inactiveSince"
        };
        return cases[pb_1.Message.computeOneofCase(this, [2])];
    }
    static fromObject(data: {
        pauseDueAt?: number;
        inactiveSince?: number;
        autoPaused?: boolean;
    }): ClusterCtlProtoCheckClusterAutoPauseRes {
        const message = new ClusterCtlProtoCheckClusterAutoPauseRes({});
        if (data.pauseDueAt != null) {
            message.pauseDueAt = data.pauseDueAt;
        }
        if (data.inactiveSince != null) {
            message.inactiveSince = data.inactiveSince;
        }
        if (data.autoPaused != null) {
            message.autoPaused = data.autoPaused;
        }
        return message;
    }
    toObject() {
        const data: {
            pauseDueAt?: number;
            inactiveSince?: number;
            autoPaused?: boolean;
        } = {};
        if (this.pauseDueAt != null) {
            data.pauseDueAt = this.pauseDueAt;
        }
        if (this.inactiveSince != null) {
            data.inactiveSince = this.inactiveSince;
        }
        if (this.autoPaused != null) {
            data.autoPaused = this.autoPaused;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.hasPauseDueAt)
            writer.writeSint64(1, this.pauseDueAt);
        if (this.hasInactiveSince)
            writer.writeSint64(2, this.inactiveSince);
        if (this.autoPaused != false)
            writer.writeBool(3, this.autoPaused);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoCheckClusterAutoPauseRes {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoCheckClusterAutoPauseRes();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.pauseDueAt = reader.readSint64();
                    break;
                case 2:
                    message.inactiveSince = reader.readSint64();
                    break;
                case 3:
                    message.autoPaused = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoCheckClusterAutoPauseRes {
        return ClusterCtlProtoCheckClusterAutoPauseRes.deserialize(bytes);
    }
}
export class ClusterCtlProtoMarkClusterAsActive extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoMarkClusterAsActive {
        const message = new ClusterCtlProtoMarkClusterAsActive({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoMarkClusterAsActive {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoMarkClusterAsActive();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoMarkClusterAsActive {
        return ClusterCtlProtoMarkClusterAsActive.deserialize(bytes);
    }
}
export class ClusterCtlProtoMarkClusterAsActiveReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
    }): ClusterCtlProtoMarkClusterAsActiveReq {
        const message = new ClusterCtlProtoMarkClusterAsActiveReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoMarkClusterAsActiveReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoMarkClusterAsActiveReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoMarkClusterAsActiveReq {
        return ClusterCtlProtoMarkClusterAsActiveReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoCloneCluster extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoCloneCluster {
        const message = new ClusterCtlProtoCloneCluster({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoCloneCluster {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoCloneCluster();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoCloneCluster {
        return ClusterCtlProtoCloneCluster.deserialize(bytes);
    }
}
export class ClusterCtlProtoCloneClusterReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        sourceClusterUuid?: Uint8Array;
        destinationClusterId?: string;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("sourceClusterUuid" in data && data.sourceClusterUuid != undefined) {
                this.sourceClusterUuid = data.sourceClusterUuid;
            }
            if ("destinationClusterId" in data && data.destinationClusterId != undefined) {
                this.destinationClusterId = data.destinationClusterId;
            }
        }
    }
    get sourceClusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set sourceClusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    get destinationClusterId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
    }
    set destinationClusterId(value: string) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data: {
        sourceClusterUuid?: Uint8Array;
        destinationClusterId?: string;
    }): ClusterCtlProtoCloneClusterReq {
        const message = new ClusterCtlProtoCloneClusterReq({});
        if (data.sourceClusterUuid != null) {
            message.sourceClusterUuid = data.sourceClusterUuid;
        }
        if (data.destinationClusterId != null) {
            message.destinationClusterId = data.destinationClusterId;
        }
        return message;
    }
    toObject() {
        const data: {
            sourceClusterUuid?: Uint8Array;
            destinationClusterId?: string;
        } = {};
        if (this.sourceClusterUuid != null) {
            data.sourceClusterUuid = this.sourceClusterUuid;
        }
        if (this.destinationClusterId != null) {
            data.destinationClusterId = this.destinationClusterId;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.sourceClusterUuid.length)
            writer.writeBytes(1, this.sourceClusterUuid);
        if (this.destinationClusterId.length)
            writer.writeString(2, this.destinationClusterId);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoCloneClusterReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoCloneClusterReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.sourceClusterUuid = reader.readBytes();
                    break;
                case 2:
                    message.destinationClusterId = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoCloneClusterReq {
        return ClusterCtlProtoCloneClusterReq.deserialize(bytes);
    }
}
export class ClusterCtlProtoResetUserPassword extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {}) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data: {}): ClusterCtlProtoResetUserPassword {
        const message = new ClusterCtlProtoResetUserPassword({});
        return message;
    }
    toObject() {
        const data: {} = {};
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoResetUserPassword {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoResetUserPassword();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoResetUserPassword {
        return ClusterCtlProtoResetUserPassword.deserialize(bytes);
    }
}
export class ClusterCtlProtoResetUserPasswordReq extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        clusterUuid?: Uint8Array;
        username?: string;
        newPassword?: string;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("clusterUuid" in data && data.clusterUuid != undefined) {
                this.clusterUuid = data.clusterUuid;
            }
            if ("username" in data && data.username != undefined) {
                this.username = data.username;
            }
            if ("newPassword" in data && data.newPassword != undefined) {
                this.newPassword = data.newPassword;
            }
        }
    }
    get clusterUuid() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set clusterUuid(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    get username() {
        return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
    }
    set username(value: string) {
        pb_1.Message.setField(this, 2, value);
    }
    get newPassword() {
        return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
    }
    set newPassword(value: string) {
        pb_1.Message.setField(this, 3, value);
    }
    static fromObject(data: {
        clusterUuid?: Uint8Array;
        username?: string;
        newPassword?: string;
    }): ClusterCtlProtoResetUserPasswordReq {
        const message = new ClusterCtlProtoResetUserPasswordReq({});
        if (data.clusterUuid != null) {
            message.clusterUuid = data.clusterUuid;
        }
        if (data.username != null) {
            message.username = data.username;
        }
        if (data.newPassword != null) {
            message.newPassword = data.newPassword;
        }
        return message;
    }
    toObject() {
        const data: {
            clusterUuid?: Uint8Array;
            username?: string;
            newPassword?: string;
        } = {};
        if (this.clusterUuid != null) {
            data.clusterUuid = this.clusterUuid;
        }
        if (this.username != null) {
            data.username = this.username;
        }
        if (this.newPassword != null) {
            data.newPassword = this.newPassword;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.clusterUuid.length)
            writer.writeBytes(1, this.clusterUuid);
        if (this.username.length)
            writer.writeString(2, this.username);
        if (this.newPassword.length)
            writer.writeString(3, this.newPassword);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ClusterCtlProtoResetUserPasswordReq {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ClusterCtlProtoResetUserPasswordReq();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.clusterUuid = reader.readBytes();
                    break;
                case 2:
                    message.username = reader.readString();
                    break;
                case 3:
                    message.newPassword = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): ClusterCtlProtoResetUserPasswordReq {
        return ClusterCtlProtoResetUserPasswordReq.deserialize(bytes);
    }
}
